export const translation = {
  "en": {
    "level": "Your Level",
    "button": {
      "start_test": "Start Test",
      "start_over": "Start Over",
      "submit": "Submit",
      "start": "start",
      "cancel": "Cancel",
      "next": "Next",
      "yes": "Yes",
      "result": "Show Result"
    },
    "input": {
      "name": "Name",
      "email": "E-mail",
      "email_confirmation": "Confirm Email",
      "dial_code": "Your Country Code",
      "phone": "Your Phone Number",
      "field_required": "The field is required",
      "phone_required": "Phone number is required",
      "email_required": "The email field is required",
      "fullname_required": "The fullname field is required"
    },
    "validation": {
      "required": "{attr} field is required",
      "confirm": "{attr} confirmation does not match"
    },
    "result_title": "Important!",
    "finish_test": "Your test is finished.",
    "finish_test_question": "Would you like to Start Over or Submit it?",
    "start_over_question": "Are you sure you want to Start Over?",
    "ready_to_test": "Are you ready to take the test?",
    "audio_instruction": "Play the audio and answer the question",
    "et": {
      "instruction_1": "You will have a maximum of 30 minutes to take the test.",
      "instruction_2": "The test consists of a total of 50 questions.",
      "instruction_3": "The graphics and audio on the Test are loaded online and require a good Internet connection to load. Please check your connection before you begin.",
      "instruction_4": "Once you click Start, the test will be considered valid. If you exit the test after you press start or during the middle of the test, you will be scored based on how many items you answered correctly before exiting.",
      "result": {
        "passed": [
          "Congratulations, {fullname}! You have earned your {level} Certificate!",
          "If you are unable to download your certificate, please ask your teacher or administrator to enable automatic certificate downloads."
        ],
        "review": [
          "We are sorry, but your score was not high enough to earn your {level} certificate.",
          "Please complete the suggested review exercises. Then, take the test again."
        ],
        "failed": [
          "Sorry, you did not pass The Certification Test. You have reached the maximum number of times you can take the Certification Test.",
          "Please contact support@nexgenenglishonline.co for info."
        ],
        "auto_next": [
          "You have failed this Certification Test three times. You can now start the next course. When neo believes you are ready, you can take this Certification Test again. We hope you pass it. Then, you will receive your Certificate. Good luck.",
          "Please contact support@nexgenenglishonline.co for info."
        ],
        "ct_landing_failed": [
          "Sorry, you did not pass The Certification Test.",
          "Please contact support@nexgenenglishonline.co for info."
        ]
      },
      "failed_test": "Sorry, you have not passed the test.",
      "failed_test_description": "Do not give up! Complete the review lesson in the neo study App and then take the test again.",
      "instruction_plus_1": "You will have a maximum of 20 minutes to take the test.",
      "instruction_plus_2": "The test consists of a total of 25 questions."
    },
    "pt": {
      "instruction_1": "You will have a maximum of 20 minutes to take the test.",
      "instruction_2": "This is an adaptive test, so the type and number of questions you are asked will depend on your performance.",
      "instruction_3": "The graphics and audio on the Test are loaded online and require a good Internet connection to load. Please check your connection before you begin.",
      "instruction_4": "You can take the test up to 3 times",
      "instruction_4_1": "You can take the test 1 time",
      "result_correlation": "Result Correlation - {level}",
      "cefr_chart": "CEFR Level Chart",
      "result": {
        "c1_pro": "Your English is excellent! Our near-native level English courses are not yet available on neo. We will contact you by email when they are ready!",
        "c1_pro_plus": "Congratulations! Your English is very advanced. Unfortunately, at this time neo cannot offer you a higher-level CEFR Certificate course. However, we do have an excellent C1-Bridge course to help you strengthen your English fluency and further enhance your ability to succeed on high-level standardized tests like the IELTS or the iBT."
      }
    },
    "test_time": "You will have a maximum of {minutes} minutes to take the test.",
    "total_questions": "The test consists of a total of {total} questions.",
    "error": {
      "invalid_credentials": "Invalid credentials",
      "repeat_audio": "You can only repeat audio once.",
      "start_over_retry": "Sorry, you can't restart the test again.",
      "connection_issue": "Please check your connection before you begin.",
      "student_already_registered": "Email already registered, please use another email address.",
      "timeout": "Your time is up",
      "email_submitted": "There is already a neoAssessment test result associated with this email."
    }
  },
  "id": {
    "level": "Level anda",
    "button": {
      "start_test": "Mulai Tes",
      "start_over": "Mulai dari awal",
      "submit": "Kirim",
      "start": "Mulai",
      "cancel": "Batal",
      "next": "Selanjutnya",
      "yes": "Ya",
      "result": "Tampilkan Hasil"
    },
    "validation": {
      "required": "{attr} Wajib diisi",
      "confirm": "Konfirmasi {attr} tidak sesuai"
    },
    "input": {
      "name": "Nama",
      "email": "Email",
      "email_confirmation": "Konfirmasi Email",
      "dial_code": "Kode Negara Anda",
      "phone": "Nomor telepon anda",
      "field_required": "Wajib diisi",
      "phone_required": "Nomor telepon wajib diisi",
      "email_required": "Email Wajib diisi",
      "fullname_required": "Nama Wajib diisi"
    },
    "result_title": "Perhatian!",
    "finish_test": "Tes Anda sudah selesai.",
    "finish_test_question": "Apakah Anda ingin Memulai atau Mengirimkan tes?",
    "start_over_question": "Apakah Anda yakin ingin mengulang tes?",
    "ready_to_test": "Apakah Anda sudah siap untuk memulai tes?",
    "audio_instruction": "Putar audio dan jawab pertanyaan.",
    "et": {
      "instruction_1": "Anda memiliki waktu maksimal 30 menit untuk mengikuti tes.",
      "instruction_2": "Tes terdiri dari total 50 pertanyaan.",
      "instruction_3": "Grafik dan audio pada Tes dimuat secara online dan membutuhkan koneksi Internet yang baik untuk memuat. Mohon periksa koneksi Anda sebelum memulai.",
      "instruction_4": "Setelah Anda mengklik Mulai, tes akan dianggap valid. Jika Anda keluar dari tes setelah Anda menekan mulai atau berada ditengah tes, Anda akan dinilai berdasarkan berapa banyak soal yang Anda jawab dengan benar sebelum keluar.",
      "result": {
        "passed": [
          "Selamat, {fullname}! Anda berhasil mendapatkan Sertifikat {level}!",
          "Silakan klik ikon menu dan pilih \"MyCertificates\" untuk mendapatkan salinan PDF dari sertifikat Anda."
        ],
        "review": [
          "Maaf, skor Anda tidak cukup tinggi untuk mendapatkan sertifikat {level} Anda.",
          "Silahkan lakukan latihan ulasan yang disarankan. Lalu ikuti tes lagi."
        ],
        "failed": [
          "Maaf, Anda tidak lulus Certification Test. Anda telah mencapai jumlah maksimum mengikuti Certification Test.",
          "Silahkan hubungi support@nexgenenglishonline.co untuk informasi."
        ],
        "auto_next": [
          "Anda telah gagal dalam Tes Sertifikasi sebanyak tiga kali. Sekarang Anda dapat memulai kursus berikutnya. Jika neo yakin Anda sudah siap, Anda dapat mengikuti Tes Sertifikasi ini lagi. Kami harap Anda lulus. Kemudian, Anda akan menerima Sertifikat. Semoga berhasil.",
          "Silahkan hubungi support@nexgenenglishonline.co untuk informasi."
        ],
        "ct_landing_failed": [
          "Maaf, Anda tidak lulus Certification Test.",
          "Silahkan hubungi support@nexgenenglishonline.co untuk informasi."
        ]
      },
      "failed_test": "Maaf, Anda belum lulus tes.",
      "failed_test_description": "Jangan menyerah! Lakukan latihan ulasan di Aplikasi neo study lalu ikuti tes lagi.",
      "instruction_plus_1": "Anda memiliki waktu maksimal 20 menit untuk menyelesaikan tes.",
      "instruction_plus_2": "Tes terdiri dari total 25 pertanyaan."
    },
    "pt": {
      "instruction_1": "Anda memiliki waktu maksimal 20 menit untuk mengikuti tes.",
      "instruction_2": "Ini adalah tes adaptif,  jenis dan jumlah pertanyaan yang ditanyakan akan bergantung pada kinerja Anda.",
      "instruction_3": "Grafik dan audio pada Tes dimuat secara online dan membutuhkan koneksi Internet yang baik untuk memuat. Mohon periksa koneksi Anda sebelum memulai.",
      "instruction_4": "Anda bisa mengikuti tes hingga 3 kali.",
      "instruction_4_1": "Anda bisa mengikuti tes hingga 1 kali.",
      "result_correlation": "Korelasi Hasil - {level}",
      "cefr_chart": "Grafik CEFR Level",
      "result": {
        "hide": "Terima kasih telah mengikuti Tes Penilaian. Silakan hubungi administrator untuk mengetahui hasilnya.",
        "c1_pro": "Bahasa Inggris Anda sangat baik! Kursus bahasa Inggris tingkat penutur asli kami belum tersedia di neo. Kami akan menghubungi Anda melalui email jika sudah siap!",
        "c1_pro_plus": "Selamat! Kemampuan Bahasa Inggris Anda sangat tinggi. Sayangnya, saat ini neo tidak dapat menawarkan kursus level Sertifikat CEFR yang lebih tinggi kepada Anda. Akan tetapi, kami memiliki kursus C1-Bridge untuk membantu memperkuat kemampuan kefasihan Bahasa Inggris Anda dan lebih meningkatkan kemampuan Anda untuk berhasil pada tes standar tingkat tinggi seperti IELTS atau iBT."
      }
    },
    "test_time": "Anda memiliki waktu maksimal {minutes} menit untuk menyelesaikan tes.",
    "total_questions": "Tes ini terdiri dari total {total} pertanyaan.",
    "error": {
      "invalid_credentials": "Data yang dimasukkan tidak sesuai.",
      "repeat_audio": "Anda hanya dapat mengulang audio satu kali.",
      "start_over_retry": "Maaf, Anda tidak dapat memulai ulang pengujian lagi.",
      "connection_issue": "Anda mengalami masalah koneksi internet. Silakan coba lagi.",
      "student_already_registered": "Email sudah terdaftar, silakan gunakan alamat email lain",
      "timeout": "Waktu sudah habis",
      "email_submitted": "Email ini sudah memiliki hasil tes neoAssessment yang terkait."
    }
  },
  "it": {
    "level": "Il test è finito",
    "button": {
      "start_test": "Inizia Il Test",
      "start_over": "Ricomincia",
      "submit": "Invio",
      "start": "Inizia",
      "cancel": "Annulla",
      "next": "Successiva",
      "yes": "Sì",
      "result": "Mostra risultato"
    },
    "validation": {
      "required": "{attr} richiesto",
      "confirm": "Conferma {attr} non è conforme"
    },
    "input": {
      "name": "Nome",
      "email": "Email",
      "email_confirmation": "Conferma Email",
      "dial_code": "Prefisso nazionale",
      "phone": "Numero di telefono",
      "field_required": "Campo richiesto",
      "phone_required": "Numero telefonico richiesto",
      "email_required": "Campo email richiesto",
      "fullname_required": "Campo nome richiesto"
    },
    "result_title": "Importante!",
    "finish_test": "Il test è finito",
    "finish_test_question": "Vuoi rifare il test o inviarlo?",
    "start_over_question": "Sei sicuro di voler rifare il test dall'inizio?",
    "ready_to_test": "Sei pronto per iniziare il test?",
    "audio_instruction": "Ascolta e rispondi alla domanda.",
    "et": {
      "instruction_1": "Avrai massimo 30 minuti per completare il test",
      "instruction_2": "Il test si compone di 50 domande totali",
      "instruction_3": "Grafica e audio del test sono caricati online e richiedono una buona connessione internet, Verifica la tua connessione internet prima di iniziare",
      "instruction_4": "Il test verrà considerato valido appena premuto il tasto Inizia, Se si abbandona il test subito dopo aver premuto Inizia o in corso di svolgimento, l'esito rifletterà il totale di risposte corrette date fino all'interruzione",
      "result": {
        "passed": [
          "Congratulazioni, {fullname}! Hai ottenuto il tuo certificato {level}!",
          "In homepage clicchi sull'icona del menù; nella sezione My Certificates potrà trovare una copia PDF del suo certificato."
        ],
        "review": [
          "Spiacenti, il punteggio ottenuto nel test è inferiore a quello necessario per il certificato {level}",
          "Svolgi gli esercizi di ripasso che ti verranno proposti e poi rifai il test."
        ],
        "failed": [
          "Spiacenti, il test non è stato superato. Hai raggiunto il numero massimo di tentativi.",
          "Contattaci su info@e-asy.it"
        ],
        "auto_next": [
          "Sei al terzo tentativo fallito di passare il test alla certificazione. Puoi iniziare il percorso successivo. Proverai di nuovo a passare questo test quando Neo riterrà che sei pronto. Riceverai il certificato del livello raggiunto appena passerai il test. In bocca al lupo!",
          "Contattaci su info@e-asy.it"
        ],
        "ct_landing_failed": [
          "Spiacenti, il test non è stato superato.",
          "Contattaci su info@e-asy.it"
        ]
      },
      "failed_test": "Spiacenti, non hai superato il test.",
      "failed_test_description": "Non arrenderti! Fai le lezioni di ripasso nell'app neo study e poi riprova il test.",
      "instruction_plus_1": "Avrai massimo 20 minuti per completare il test",
      "instruction_plus_2": "Il test si compone di 25 domande totali"
    },
    "pt": {
      "instruction_1": "Avrai massimo 20 minuti per completare il test",
      "instruction_2": "Il test è adattivo, numero e tipo di domande dipendono da come rispondi",
      "instruction_3": "Grafica e audio del test sono caricati online e richiedono una buona connessione internet, Verifica la tua connessione internet prima di iniziare",
      "instruction_4": "Puoi ripetere il test massimo 3 volte.",
      "instruction_4_1": "Puoi fare il test una volta.",
      "result_correlation": "Correlazione dei risultati - {level}",
      "cefr_chart": "Grafico del livello CEFR",
      "result": {
        "c1_pro": "Il tuo livello d'inglese è eccellente! I nostri corsi per studenti avanzati non sono ancora disponibili su neo. Appena lo saranno ti contatteremo via mail.",
        "c1_pro_plus": "Congratulazioni! Il tuo livello d'inglese è molto avanzato. Al momento neo non ha un percorso alla certificazione superiore al tuo livello, ma possiamo proporti un eccellente corso C1-Bridge per rinforzare la tua fluency e facilitarti il superamento di esami standard di livello alto come IELTS o iBT."
      }
    },
    "test_time": "Avrai massimo {minutes} minuti per completare il test",
    "total_questions": "Il test si compone di {total} domande totali",
    "error": {
      "invalid_credentials": "Dati inseriti non corretti.",
      "repeat_audio": "Puoi ripetere l'audio solo una volta.",
      "start_over_retry": "Spiacenti, non puoi riavviare il test.",
      "connection_issue": "Stai riscontrando problemi di connessione a Internet. Per favore riprova.",
      "student_already_registered": "Indirizzo mail già registrato, per favore inserirne un altro.",
      "timeout": "Il tuo tempo è scaduto",
      "email_submitted": "Esiste già un risultato del test neoAssessment associato a questa email"
    }
  },
  "fr": {
    "level": "Votre Niveau",
    "button": {
      "start_test": "Démarrez le test",
      "start_over": "Recommencer",
      "submit": "Soumettre",
      "start": "Démarrer",
      "cancel": "Annuler",
      "next": "Suivant",
      "yes": "Oui",
      "result": "Afficher le résultat"
    },
    "input": {
      "name": "Nom",
      "email": "Email",
      "email_confirmation": "Confirmer l'adresse email",
      "dial_code": "Code du pays",
      "phone": "Votre numéro de téléphone",
      "field_required": "Champ requis",
      "phone_required": "Votre numéro de téléphone requis",
      "email_required": "Le champ \"email\" est requis",
      "fullname_required": "Le champ Nom est requis"
    },
    "validation": {
      "required": "Champ requis",
      "confirm": "Votre {attr} de confirmation ne correspond pas."
    },
    "result_title": "Important!",
    "finish_test": "Votre test est terminé.",
    "finish_test_question": "Souhaitez-vous recommencer ou bien soumettre le test?",
    "start_over_question": "Voulez-vous vraiment redémarrer le test?",
    "ready_to_test": "Êtes-vous prêt à passer le test?",
    "audio_instruction": "Écoutez l'audio et répondez à la question.",
    "et": {
      "instruction_1": "Vous disposerez d'un maximum de 30 minutes pour compléter le test",
      "instruction_2": "Le test comporte 50 questions au total.",
      "instruction_3": "Les graphismes et l'audio du test sont chargés en ligne et nécessitent une bonne connexion Internet. Veuillez vérifier votre connexion avant de commencer.",
      "instruction_4": "Une fois que vous cliquez sur Démarrer, le test sera considéré comme valable. Si vous quittez le test après avoir appuyé sur Démarrer ou au milieu du test, vous serez noté en fonction du nombre d'items auxquels vous répondez correctement avant de quitter.",
      "result": {
        "passed": [
          "Toutes nos félicitations, {fullname}! Vous avez obtenu votre certificat {Level}!",
          "Veuillez cliquer sur le icône du menu hamburger sur l'écran principal et sélectionner \"My Certificates\" pour obtenir une copie PDF de votre certificat."
        ],
        "review": [
          "Nous sommes désolés, mais votre score n'était pas assez élevé pour obtenir votre certificat de {level}.",
          "Veuillez compléter les exercices de révision suggérés. Ensuite, refaites le test."
        ],
        "failed": [
          "Désolé, vous n'avez pas réussi le test de certification. Vous avez atteint le nombre maximum d'essais Test de Certification.",
          "Veuillez contacter support@nexgenenglishonline.co pour plus d'informations."
        ],
        "auto_next": [
          "You have failed this Certification Test three times. You can now start the next course. When neo believes you are ready, you can take this Certification Test again. We hope you pass it. Then, you will receive your Certificate. Good luck.",
          "Veuillez contacter support@nexgenenglishonline.co pour plus d'informations."
        ],
        "ct_landing_failed": [
          "Désolé, vous n'avez pas réussi le test de certification.",
          "Veuillez contacter support@nexgenenglishonline.co pour plus d'informations."
        ]
      },
      "failed_test": "Désolé mais vous n'avez pas réussi le test.",
      "failed_test_description": "N'abandonnez pas! Terminez la leçon de révision dans l'application neo Study, puis refaites le test.",
      "instruction_plus_1": "Vous disposerez d'un maximum de 20 minutes pour compléter le test",
      "instruction_plus_2": "Le test comporte 25 questions au total."
    },
    "pt": {
      "instruction_1": "Vous disposerez d'un maximum de 20 minutes pour compléter le test",
      "instruction_2": "Il s'agit d'un test adaptatif, donc le type et le nombre de questions qui vous seront posées dépendront de votre taux de réussite.",
      "instruction_3": "Les graphismes et l'audio du test sont chargés en ligne et nécessitent une bonne connexion Internet. Veuillez vérifier votre connexion avant de commencer.",
      "instruction_4": "Vous pouvez passer le test jusqu’à 3 fois.",
      "instruction_4_1": "Vous pouvez passer le test 1 fois.",
      "result_correlation": "Corrélations des résultats - {level}",
      "cefr_chart": "Tableau des niveaux du CEFR",
      "result": {
        "hide": "Merci d'avoir passé le test d'évaluation. Veuillez contacter votre administrateur afin de recevoir les résultats.",
        "c1_pro": "Votre anglais est excellent! Nos cours d'anglais de niveau quasi natif ne sont pas encore disponibles sur neo. Nous vous contacterons par e-mail lorsqu'ils seront prêts!",
        "c1_pro_plus": "Félicitations! Votre anglais est très avancé. Malheureusement, pour le moment, neo ne peut pas vous proposer de cours de certificat CEFR de niveau supérieur. Cependant, nous avons un excellent cours C1-Bridge pour vous aider à renforcer votre maîtrise de l'anglais et à améliorer encore votre capacité à réussir des tests standardisés de haut niveau comme l'IELTS ou l'iBT."
      }
    },
    "test_time": "Vous disposerez d'un maximum de {minutes} minutes pour compléter le test",
    "total_questions": "Le test comporte {total} questions au total.",
    "error": {
      "invalid_credentials": "Informations d'identification non valables",
      "repeat_audio": "Vous ne pouvez réécouter l'audio qu'une seule fois.",
      "start_over_retry": "Désolé, vous ne pouvez pas réessayer le test.",
      "connection_issue": "Veuillez vérifier votre connexion avant de commencer..",
      "student_already_registered": "Adresse e-mail déjà enregistrée, veuillez utiliser une autre adresse.",
      "timeout": "Votre temps est écoulé",
      "email_submitted": "Un résultat de test neoAssessment est déjà associé à cet e-mail"
    }
  },
  "cz": {
    "level": "VAŠE VÝCHOZÍ ÚROVEŇ",
    "button": {
      "start_test": "ZAHÁJIT TEST",
      "start_over": "Provést znovu",
      "submit": "Odeslat",
      "start": "Začít",
      "cancel": "Zrušit",
      "next": "dále",
      "yes": "Ano",
      "result": "Zobrazit výsledek"
    },
    "input": {
      "name": "Jméno",
      "email": "E-mail",
      "email_confirmation": "Potvrďte e-mail",
      "dial_code": "Předčíslí země",
      "phone": "Vaše telefonní číslo",
      "field_required": "Povinný údaj",
      "phone_required": "Telefonní číslo je povinný údaj",
      "email_required": "E-mail je povinný údaj",
      "fullname_required": "Jméno je povinný údaj"
    },
    "validation": {
      "required": "{attr} je povinný údaj",
      "confirm": "Potvrzovací {attr} se neshoduje"
    },
    "result_title": "Důležité!",
    "finish_test": "Test skončil.",
    "finish_test_question": "Přejete si test provést znovu anebo odeslat k vyhodnocení?",
    "start_over_question": "Určitě chcete test provést znovu?",
    "ready_to_test": "Jste připraveni zahájit test?",
    "audio_instruction": "Poslechněte si audio a odpovězte na otázku.",
    "et": {
      "instruction_1": "Test potrvá maximálně 30 minut.",
      "instruction_2": "Test se skládá celkem z 50 otázek.",
      "instruction_3": "Grafika a audio testu se načítají online, a vyžadují tedy kvalitní připojení. Než se do testu pustíte, zkontrolujte si prosím internetové připojení.",
      "instruction_4": "Jakmile zmáčknete Začít, bude test považován za zahájený. Ukončíte-li test po zmáčknutí Začít nebo uprostřed testu, test bude vyhodnocen na základě počtu správných odpovědí před ukončením.",
      "result": {
        "passed": [
          "Srdečně Vám gratulujeme, {fullname}! Úspěšně jste absolvoval/a certifikaci {level}.",
          "Svůj certifikát v PDF získáte po kliknutí na menu/ikonku hamburgeru na hlavní obrazovce a zvolení \"MyCertificates\"."
        ],
        "review": [
          "Je nám líto, výsledek nestačil na certifikaci {level}.",
          "Prosím zopakujte si navržené aktivity. Pak test proveďte znovu."
        ],
        "failed": [
          "Je nám líto, výsledek na certifikaci nestačil. Bohužel bylo dosaženo maximálního počtu opakování certifikačního testu.",
          "Pro další informace prosím kontaktujte svého obchodního partnera."
        ],
        "auto_next": [
          "V tomto certifikačním testu jste třikrát neuspěli. Můžete začít studovat další úroveň a jakmile neo pozná, že jste připraveni, můžete certifikační test absolvovat znovu. Doufáme, že ho složíte. Poté obdržíte certifikát. Hodně štěstí!",
          "Pro další informace prosím kontaktujte svého obchodního partnera."
        ],
        "ct_landing_failed": [
          "Je nám líto, výsledek na certifikaci nestačil.",
          "Pro další informace prosím kontaktujte svého obchodního partnera."
        ]
      },
      "failed_test": "Test se Vám bohužel nepodařil.",
      "failed_test_description": "Nevzdávejte to. Projděte si v neo Study opakovací lekce  a pak se do  testu pusťte znovu.",
      "instruction_plus_1": "Test potrvá maximálně 20 minut.",
      "instruction_plus_2": "Test se skládá celkem z 25 otázek."
    },
    "pt": {
      "instruction_1": "Test potrvá maximálně 20 minut.",
      "instruction_2": "Tento test je adaptivní, tzn. že typ a počet prezentovaných otázek závisí na tom, jak si v testu vedete.",
      "instruction_3": "Grafika a audio testu se načítají online, a vyžadují tedy kvalitní připojení. Než se do testu pustíte, zkontrolujte si prosím internetové připojení.",
      "instruction_4": "Test můžete provést až třikrát.",
      "result_correlation": "Porovnání výsledku s jinými testy - {level}",
      "cefr_chart": "Tabulka úrovní CEFR",
      "result": {
        "hide": "Děkujeme za provedení testu. Ohledně výsledků se prosím obraťte na svého administrátora.",
        "c1_pro": "Máte vynikající angličtinu! Kurzy na úrovni téměř rodilého mluvčího na neo ještě bohužel nejsou k dispozici. Až budou, zkontaktujeme vás.",
        "c1_pro_plus": "Gratulujeme, máte velmi vysokou úroveň angličtiny! neo Vám nyní bohužel nemůže nabídnout kurz vyšší úrovně zakončený certifikací CEFR, máme však vynikající kurz C1-Bridge, který Vám posílí plynulost v angličtině a zvýší  úspěšnost ve standardizovaných testech nejvyšší úrovně, jako je IELTS nebo TOEFL iBT."
      }
    },
    "test_time": "Test potrvá maximálně {minutes} minut.",
    "total_questions": "Test se skládá celkem z {total} otázek.",
    "error": {
      "invalid_credentials": "Neplatná identifikace",
      "repeat_audio": "Audio lze vyslechnout znovu jen jednou.",
      "start_over_retry": "Je nám líto, ale test nelze opakovat.",
      "connection_issue": "Než se do testu pustíte, zkontrolujte si prosím internetové připojení.",
      "student_already_registered": "Tento e-mail již existuje.  Prosím použijte jinou e-mailovou adresu.",
      "timeout": "Váš čas vypršal",
      "email_submitted": "S touto e-mailovou adresou je již spojen výsledek testu neoAssessment"
    }
  },
  "hu": {
    "level": "AZ ÖN ELÉRT SZINTJE",
    "button": {
      "start_test": "Teszt Indítása",
      "start_over": "ÚJRAKEZDÉS",
      "submit": "KÜLDÉS",
      "start": "Indítás",
      "cancel": "Mégsem",
      "next": "Tovább",
      "yes": "Igen",
      "result": "Eredmény megtekintése"
    },
    "input": {
      "name": "Név",
      "email": "E-mail cím megerősítése",
      "email_confirmation": "E-mail cím megerősítése",
      "dial_code": "Országkód",
      "phone": "Az ön telefonszáma",
      "field_required": "Kötelezően kitöltendő mező.",
      "phone_required": "Kérem adjon meg egy telefonszámot.",
      "email_required": "Kérem adjon meg egy e-mail címet.",
      "fullname_required": "Kérem adjon meg egy Név címet."
    },
    "validation": {
      "required": "Kérem adjon meg egy {attr}",
      "confirm": "Az {attr} címek nem azonosak."
    },
    "result_title": "Fontos!",
    "finish_test": "A teszt befejeződött.",
    "finish_test_question": "Beküldi a kitöltött tesztet, vagy szeretné újra elvégezni?",
    "start_over_question": "Biztosan újra szeretné indítani a tesztet?",
    "ready_to_test": "Készen áll a teszt elkezdésére?",
    "audio_instruction": "Játssza le a hangfelvételt és válaszolja meg a kérdést!",
    "et": {
      "instruction_1": "Maximum 30 perc van a teszt elvégzésére.",
      "instruction_2": "Ez a teszt összesen 50 kérdésből áll.",
      "instruction_3": "A tesztben levő képek és hangfelvételek online kerülnek letöltésre, ehhez megfelelő internet kapcsolatra van szükség. Kérjük ellenőrizze az internet kapcsolatot indítás előtt!",
      "instruction_4": "Ha megnyomja az Indítás gombot, a teszteredmény érvényesnek minősül. Ha az indítás után vagy a tesztkitöltés közben kilép a tesztből, akkor az addig megválaszolt kérdések alapján lesz a teszt kiértékelve.",
      "result": {
        "passed": [
          "Gratulálunk, {fullname}! Megszerezted a {level} szintű nyelvvizsga tanúsítványt!",
          "Kattintson a Hamburger Menüre a fő képernyőn és válassza a \"MyCertificates\" menüpontot, hogy letöltse a vizsga tanúsítványt pdf formátumban."
        ],
        "review": [
          "Sajnáljuk, de nem sikerült elérned a {level} szinthez szükséges pontszámot.",
          "Kérjük végezd el a javasolt ismétlő gyakorlatokat majd végezd el a tesztet ismét."
        ],
        "failed": [
          "Sajnáljuk, de nem sikerült letenned a Nyelvvizsga tesztet. Kimerítetted a nyelvvizsga kísérletek maximális számát.",
          "Kérjük vedd fel velünk a kapcsolatot a support@nexgenenglishonline.co e-mail címen."
        ],
        "auto_next": [
          "You have failed this Certification Test three times. You can now start the next course. When neo believes you are ready, you can take this Certification Test again. We hope you pass it. Then, you will receive your Certificate. Good luck.",
          "Kérjük vedd fel velünk a kapcsolatot a support@nexgenenglishonline.co e-mail címen."
        ],
        "ct_landing_failed": [
          "Sajnáljuk, de nem sikerült letenned a Nyelvvizsga tesztet.",
          "Kérjük vedd fel velünk a kapcsolatot a support@nexgenenglishonline.co e-mail címen."
        ]
      },
      "failed_test": "Sajnáljuk, de a teszt nem sikerült.",
      "failed_test_description": "Ne add fel! Végezd el az ismétlő leckét a neo study App-ban és utána végezd el a tesztet újból.",
      "instruction_plus_1": "Maximum 20 perc van a teszt elvégzésére.",
      "instruction_plus_2": "Ez a teszt összesen 25 kérdésből áll."
    },
    "pt": {
      "instruction_1": "Maximum 20 perc áll rendelkezésre a teszt kitöltéséhez.",
      "instruction_2": "Ez egy adaptív teszt, a feltett kérdések típusa és száma függ az Ön teljesítményétől.",
      "instruction_3": "A tesztben levő képek és hangfelvételek online kerülnek letöltésre, ehhez megfelelő internet kapcsolatra van szükség. Kérjük ellenőrizze az internet kapcsolatot indítás előtt!",
      "instruction_4": "A tesztet legfeljebb 3 alkalommal végezheti el.",
      "instruction_4_1": "A tesztet egy alkalommal végezheti el.",
      "result_correlation": "Az elért eredmény más rendszerek szerint - {level}",
      "cefr_chart": "CEFR Nyelvtudás Szintek",
      "result": {
        "c1_pro": "Az angol tudásod kiváló! Anyanyelvi szintű angol nyelvtanfolyamaink sajnos még nem elérhetőek a neo felületen. E-mailben értesítünk, ha elérhetővé válnak!",
        "c1_pro_plus": "Gratulálunk! Az angol tudásod nagyon magas szintű. Sajnos jelenleg még nem tudunk ennél magasabb CEFR nyelvvizsga szintű tanfolyamokat felajánlani. Felajánljuk azonban a kiváló C1-Bridge tanfolyamunkat, ami erősíti az angol nyelvtudásodat és segít a felkészülésben az olyan magas szintű standardizált nyelvvizsgákra, mint az IELTS vagy az iBT."
      }
    },
    "test_time": "Maximum {minutes} perc van a teszt elvégzésére.",
    "total_questions": "Ez a teszt összesen {total} kérdésből áll.",
    "error": {
      "invalid_credentials": "Helytelenül beírt adatok.",
      "repeat_audio": "A hangfelvétel csak egyszer ismételhető.",
      "start_over_retry": "Sajnálom, de a tesztet nem lehet megismételni.",
      "connection_issue": "Kérjük ellenőrizze az internet kapcsolatot indítás előtt!",
      "student_already_registered": "Ez az e-mail cím már regisztrálva van. Kérjük használjon másik e-mail címet.",
      "timeout": "Lejárt az időd",
      "email_submitted": "Ehhez az e-mailhez már tartozik egy neoAssessment teszteredmény"
    }
  },
  "kz": {
    "level": "СІЗДІҢ ДЕҢГЕЙІҢІЗ",
    "button": {
      "start_test": "ТЕСТТІ БАСТАУ",
      "start_over": "Қайта бастау",
      "submit": "Тест нәтижесін жіберу",
      "start": "Бастау",
      "cancel": "Жою",
      "next": "Келесі",
      "yes": "Иә",
      "result": "Нәтижені көрсету"
    },
    "validation": {
      "required": "{attr} өрісін міндетті түрде толтыруыңыз кажет.",
      "confirm": "Сіздің растауға арналған {attr} сәйкес келмейді."
    },
    "input": {
      "name": "Аты-жөні",
      "email": "Электрондық пошта",
      "email_confirmation": "Электрондық поштаны растау",
      "dial_code": "Ел коды",
      "phone": "Ваш номер телефона",
      "field_required": "Бұл өріс орны міндетті түрде толтырылады.",
      "phone_required": "Телефон нөмеріңізді міндетті түрде толтыруыңыз қажет.",
      "email_required": "Электрондық пошта өрісін міндетті түрде толтыруыңыз кажет.",
      "fullname_required": "Аты-жөні пошта өрісін міндетті түрде толтыруыңыз кажет."
    },
    "result_title": "Маңызды!",
    "finish_test": "Сіздің тестіңіз аяқталды.",
    "finish_test_question": "Сіз тестті қайта бастағыңыз немесе нәтижеңізді жібергіңіз келе ме?",
    "start_over_question": "Сіз тестті қайта бастағыңыз келетініне сенімдісіз бе?",
    "ready_to_test": "Сіз тест тапсыруға дайынсыз ба?",
    "audio_instruction": "Аудионы қосып, сұраққа жауап беріңіз.",
    "et": {
      "instruction_1": "Сізге тестті өтуге 30 минуттай уақыт беріледі.",
      "instruction_2": "Тест жалпы 50 сұрақтан тұрады.",
      "instruction_3": "Тесттегі графика мен аудио онлайн жүктелінеді және жүктеу үшін жақсы интернет байланысы қажет. Жұмысты бастамас бұрын интернет қосылымын тексеріңіз.",
      "instruction_4": "Егер сіз бастау батырмасын басқаннан кейін немесе тесттің ортасында тесттен шықсаңыз, сізге шығу алдында қанша ұпайға дұрыс жауап бергеніңізге байланысты балл беріледі.",
      "result": {
        "passed": [
          "Құттықтаймыз, {fullname}! Сіз {level} сертификатын алдыңыз!",
          "Сертификатыңыздың PDF көшірмесін жүктеп алу үшін басты экрандағы үш жолды мәзірді басып, \"MyCertificates\" тармағын таңдаңыз."
        ],
        "review": [
          "Кешіріңіз, бірақ сіздің баллыңыз {level} сертификатын алуға жеткіліксіз болды.",
          "Ұсынылған шолу жаттығуларын аяқтаңыз. Содан кейін сынақты қайтадан тапсырыңыз."
        ],
        "failed": [
          "Кешіріңіз, сіз Сертификаттау сынағынан өте алмадыңыз. Сертификаттау тестін өтуге берілген максималды әрекеттер санын қолдандыңыз.",
          "Ақпарат алу үшін support@nexgenenglishonline.co сайтына хабарласыңыз."
        ],
        "auto_next": [
          "You have failed this Certification Test three times. You can now start the next course. When neo believes you are ready, you can take this Certification Test again. We hope you pass it. Then, you will receive your Certificate. Good luck.",
          "Ақпарат алу үшін support@nexgenenglishonline.co сайтына хабарласыңыз."
        ],
        "ct_landing_failed": [
          "Кешіріңіз, сіз Сертификаттау сынағынан өте алмадыңыз.",
          "Ақпарат алу үшін support@nexgenenglishonline.co сайтына хабарласыңыз."
        ]
      },
      "failed_test": "Өкінішке орай сіздің балыңыз {деңгей} сертификатын растау үшін жеткіліксіз болды.",
      "failed_test_description": "Ұсынылған шолу шараларын аяқтаңыз. Содан кейін тестті қайта тапсырыңыз.",
      "instruction_plus_1": "Сізге тестті өтуге 20 минуттай уақыт беріледі.",
      "instruction_plus_2": "Тест жалпы 25 сұрақтан тұрады."
    },
    "pt": {
      "instruction_1": "Сізге тестті өтуге 20 минуттай уақыт беріледі.",
      "instruction_2": "Бұл бейімделме тест, сондықтан қойылатын сұрақтардың түрі мен саны сіздің орындау көрсеткіштеріңізге байланысты болады.",
      "instruction_3": "Тесттегі графика мен аудио онлайн жүктелінеді және жүктеу үшін жақсы интернет байланысы қажет. Жұмысты бастамас бұрын интернет қосылымын тексеріңіз.",
      "instruction_4": "Сіз тестті 3 рет тапсыра аласыз.",
      "instruction_4_1": "Сіз тестті 1 рет тапсыра аласыз.",
      "result_correlation": "Нәтиже корреляциясы - {level}",
      "cefr_chart": "Графикалық CEFR Level",
      "result": {
        "c1_pro": "Сіздің ағылшын тіліңіз өте жақсы! Біздің ана тілі деңгейіндегі ағылшын тілі курстарымыз neo-да әлі жоқ. Олар дайын болған кезде біз сізбен электрондық пошта арқылы хабарласамыз!",
        "c1_pro_plus": "Құттықтаймыз! Сіздің ағылшын тілі деңгейіңіз өте жоғары. Өкінішке орай, қазіргі уақытта нео сізге жоғары деңгейлі CEFR сертификаты курсын ұсына алмайды. Алайда бізде ағылшын тілін жетік білуге және IELTS немесе iBT сияқты жоғары деңгейлі стандартталған тестілерге дайындалуға көмектесетін тамаша C1-Bridge курсы бар."
      }
    },
    "test_time": "Сізге тестті өтуге {minutes} минуттай уақыт беріледі.",
    "total_questions": "Тест жалпы {total} сұрақтан тұрады..",
    "error": {
      "invalid_credentials": "Қате есептік деректер..",
      "repeat_audio": "Аудионы тек бір рет қайталауға болады..",
      "start_over_retry": "Кешіріңіз, сынақты қайталау мүмкін емес.",
      "connection_issue": "Жұмысты бастамас бұрын интернет қосылымын тексеріңіз.",
      "student_already_registered": "Бұл электрондық пошта тіркелген, басқасын қолданыңыз.",
      "timeout": "Сіздің уақытыңыз бітті",
      "email_submitted": "Бұл электрондық поштаға neoAssessment тестінің нәтижесі бұрыннан тіркелген"
    }
  },
  "kr": {
    "level": "평가 결과 레벨",
    "button": {
      "start_test": "평가 시작",
      "start_over": "다시 시작",
      "submit": "제출",
      "start": "시작",
      "cancel": "취소",
      "next": "다음",
      "yes": "예",
      "result": "결과 보기"
    },
    "validation": {
      "required": "{attr} 주소 입력",
      "confirm": "확인 {attr} 적합하지 않음"
    },
    "input": {
      "name": "이름",
      "email": "이메일",
      "email_confirmation": "이메일 확인",
      "dial_code": "국가코드",
      "phone": "휴대폰 번호",
      "field_required": "학습자 정보를 입력해 주세요",
      "phone_required": "휴대폰 번호 입력",
      "email_required": "이메일 주소 입력",
      "fullname_required": "이름 주소 입력"
    },
    "result_title": "중요!",
    "finish_test": "평가를 완료했습니다",
    "finish_test_question": "평가 다시 시작 또는 평가 결과 제출",
    "start_over_question": "평가를 다시 시작하겠습니까",
    "ready_to_test": "평가를 치를 준비가 되었습니까",
    "audio_instruction": "듣고 질문에 답하세요",
    "et": {
      "instruction_1": "평가 시간은 최대 30분 입니다",
      "instruction_2": "평가 문항은 총 50 문항입니다",
      "instruction_3": "온라인으로 듣고 보는 평가가 진행됩니다. 인터넷 환경이 좋은 곳에서 진행해 주세요. 시작하기 전에 인터넷이 연결되어 있는지 확인해 주세요",
      "instruction_4": "평가 시작 버튼을 눌러 평가가 진행되는 도중에 중단할 경우 그때까지 맞춘 정답 수에 따라 점수를 계산합니다.",
      "result": {
        "passed": [
          "축하합니다, {fullname}! {level} 인증서를 획득하셨습니다.",
          "레벨 인증서 PDF 사본을 다운받기 위해서는 첫 학습화면 왼쪽 위의 三를 클릭한 후 \"MyCertificates\"를 누릅니다."
        ],
        "review": [
          "죄송하지만, {level} 인증서 취득에 필요한 점수에 도달하지 못했습니다.",
          "제안드린 복습 과정을 완료해 주세요. 복습을 완료하고, 다시 시험을 보세요."
        ],
        "failed": [
          "죄송합니다, 인증 테스트를 통과하지 못했습니다. 인증 시험을 볼 수 있는 최대 횟수에 도달했습니다.",
          "자세한 내용은 support@nexgenenglishonline.co에 문의하세요."
        ],
        "auto_next": [
          "인증 테스트에 세 번째 실패했습니다. 다음 과정의 학습은 바로 시작할 수 있습니다. neo 시스템은 당신이 준비가 되었다고 생각될 때, 인증 테스트를 다시 볼 수 있도록 합니다. 다시 시험을 치를 때는 꼭 합격하시기 바랍니다. 합격하면, 인증서가 발급됩니다. 행운을 빕니다.",
          "자세한 내용은 support@nexgenenglishonline.co에 문의하세요."
        ],
        "ct_landing_failed": [
          "죄송합니다, 인증 테스트를 통과하지 못했습니다.",
          "자세한 내용은 support@nexgenenglishonline.co에 문의하세요."
        ]
      },
      "failed_test": "아쉽습니다. 테스트를 통과하지 못했습니다.",
      "failed_test_description": "포기하지 마세요. neo 스터디앱으로 복습 레슨을 완료하고, 테스트를 다시 치르면 됩니다.",
      "instruction_plus_1": "평가 시간은 최대 20분 입니다",
      "instruction_plus_2": "평가 문항은 총 25 문항입니다"
    },
    "pt": {
      "instruction_1": "평가 시간은 최대 20분 입니다",
      "instruction_2": "맞춤형 평가이기 때문에 문제 유형과 문항 수는 학습자마다 다르게 제시됩니다",
      "instruction_3": "온라인으로 듣고 보는 평가가 진행됩니다. 인터넷 환경이 좋은 곳에서 진행해 주세요. 시작하기 전에 인터넷이 연결되어 있는지 확인해 주세요",
      "instruction_4": "시험을 최대 3번까지 볼 수 있습니다.",
      "instruction_4_1": "시험을 1번만 볼 수 있습니다.",
      "result_correlation": "당신의 {Level} 획득을 인증합니다",
      "cefr_chart": "CEFR 레벨 차트",
      "result": {
        "hide": "평가에 참여해 주셔서 감사합니다. 평가 결과는 관리자에게 문의해 주세요.",
        "c1_pro": "뛰어난 영어 실력입니다! 거의 원어민 수준에 가까운 당신의 실력에 맞는  neo 코스는 현재 개발 중입니다. 준비가 완료되면 이메일로 연락드리겠습니다.",
        "c1_pro_plus": "축하합니다! 당신의 영어 실력은 매우 높은 단계입니다. 안타깝게도 당신의 실력에 맞는 더 높은 단계의 CEFR 인증 과정은 현재 개발 중입니다. 하지만, 당신의 영어 유창성을 더욱 향상시키고 IELTS나 iBT와 같은 공인 시험에서 높은 성적을 얻을 수 있도록 돕는 훌륭한 C1-Bridge 과정이 있습니다."
      }
    },
    "test_time": "평가 시간은 최대 {minutes}분 입니다",
    "total_questions": "평가 문항은 총 {total} 문항입니다",
    "error": {
      "invalid_credentials": "잘못 입력하셨습니다",
      "repeat_audio": "한번 더 들어볼 수 있습니다",
      "start_over_retry": "죄송합니다. 테스트를 반복할 수 없습니다.",
      "connection_issue": "시작하기 전에 인터넷이 연결되어 있는지 확인해 주세요",
      "student_already_registered": "등록된 이메일 주소입니다. 다른 이메일 주소를 사용해 주세요",
      "timeout": "너의 시간이 다됐다",
      "email_submitted": "이 이메일에는 이미 neoAssessment 테스트 결과가 연결되어 있습니다"
    }
  },
  "ru": {
    "level": "ВАШ УРОВЕНЬ",
    "button": {
      "start_test": "Начать",
      "start_over": "Начать заново",
      "submit": "Сохранить результат",
      "start": "Начать",
      "cancel": "Отмена",
      "next": "Далее",
      "yes": "Да",
      "result": "Показать результат"
    },
    "validation": {
      "required": "Введите {attr}",
      "confirm": "{attr} не совпадает "
    },
    "input": {
      "name": "Имя",
      "email": "Адрес электронной почты",
      "email_confirmation": "Подтвердите адрес электронной почты",
      "dial_code": "Код страны",
      "phone": "Ваш номер телефона",
      "field_required": "Данное поле обязательно для заполнения",
      "phone_required": "Введите номер телефона",
      "email_required": "Введите адрес электронной почты",
      "fullname_required": "Введите Имя электронной почты"
    },
    "result_title": "Важно!",
    "finish_test": "Тест завершен",
    "finish_test_question": "Сохранить результат или начать заново?",
    "start_over_question": "Вы уверенны, что хотите сдать тест заново?",
    "ready_to_test": "Вы готовы начать тест?",
    "audio_instruction": "Прослушайте аудио и ответьте на вопрос",
    "et": {
      "instruction_1": "На сдачу теста вам понадобится не больше 30 минут",
      "instruction_2": "Тест состоит из 50 вопросов",
      "instruction_3": "Изображения и аудио к тесту загружаются онлайн, поэтому необходима хорошая скорость интернета. Пожалуйста проверьте подключение к интернету перед началом теста",
      "instruction_4": "Тест считается начатым после того, как вы нажмете на \"Начать\". Если вы покинете тест в середине или после того, как начнёте его, ваши баллы будут начисляться исходя из количества вопросов, на которые вы ответили правильно до того, как покинули тест.",
      "result": {
        "passed": [
          "Поздравляем, {fullname}! Вы получили сертификат подтверждающий уровень {level}!",
          "Для получения копии сертификата в формате PDF, перейдите в раскрывающееся меню и нажмите на \"MyCertificates\"."
        ],
        "review": [
          "К сожалению, ваших баллов было недостаточно для получения сертификата, подтверждающего уровень {level}",
          "Пожалуйста попробуйте сдать тест ещё раз после того, как завершите повторение пройденного материала."
        ],
        "failed": [
          "К сожалению, вы не прошли сертификационный тест. Вы достигли максимального количества попыток, данных для прохождения теста на получение сертификата. Пожалуйста.",
          "свяжитесь с support@nexgenenglishonline.co для получения дальнейшей информации."
        ],
        "auto_next": [
          "You have failed this Certification Test three times. You can now start the next course. When neo believes you are ready, you can take this Certification Test again. We hope you pass it. Then, you will receive your Certificate. Good luck.",
          "свяжитесь с support@nexgenenglishonline.co для получения дальнейшей информации."
        ],
        "ct_landing_failed": [
          "К сожалению, вы не прошли сертификационный тест.",
          "свяжитесь с support@nexgenenglishonline.co для получения дальнейшей информации."
        ]
      },
      "failed_test": "К сожалению, вы не прошли тестирование.",
      "failed_test_description": "Не сдавайтесь! Завершите уроки на повторение в приложении \"neo study\", а затем снова пройдите тестирование.",
      "instruction_plus_1": "У вас есть максимум 20 минут на сдачу теста",
      "instruction_plus_2": "Тест состоит из 25 вопросов"
    },
    "pt": {
      "instruction_1": "У вас есть максимум 20 минут на сдачу теста",
      "instruction_2": "Данный тест является адаптивным, поэтому вид и количество задаваемых вопросов напрямую зависит от ваших знаний",
      "instruction_3": "Изображения и аудио к тесту загружаются онлайн, поэтому необходима хорошая скорость интернета. Пожалуйста проверьте подключение к интернету перед началом теста",
      "instruction_4": "Тест можно сдать не более 3 раз",
      "instruction_4_1": "Тест можно сдать не более 1 раз",
      "result_correlation": "Корреляция результата {level}",
      "cefr_chart": "Уровень по шкале CEFR",
      "result": {
        "c1_pro": "У вас отличный уровень английского языка! Наши курсы английского на уровне, близком к носителю, ещё не доступны в neo. Мы свяжемся с Вами по электронной почте, когда они появятся!",
        "c1_pro_plus": "Поздравляем! Ваш уровень английского языка очень продвинутый. К сожалению, в настоящее время 'neo' не может предложить Вам Сертификационный курс CEFR более высокого уровня. Тем не менее, у нас есть отличный курс C1-Bridge, который поможет вам усовершенствовать навыки владения английским языком и улучшить способности необходимые для успешной сдачи стандартизированных тестов высокого уровня, таких как IELTS или iBT."
      }
    },
    "test_time": "У вас есть максимум {minutes} минут на сдачу теста",
    "total_questions": "Тест состоит из {total} вопросов",
    "error": {
      "invalid_credentials": "Неверный формат данных",
      "repeat_audio": "Вы можете прослушать аудио только один раз",
      "start_over_retry": "К сожалению, тест не может быть повторен.",
      "connection_issue": "Пожалуйста проверьте подключение к интернету перед началом теста",
      "student_already_registered": "Это электронная почта уже зарегистрирована, воспользуйтесь другой.",
      "timeout": "Ваше время вышло",
      "email_submitted": "С этим адресом электронной почты уже связан результат теста neoAssessment"
    }
  },
  "si": {
    "level": "VAŠA POČIATOČNÁ ÚROVEŇ",
    "button": {
      "start_test": "Začať Test",
      "start_over": "Začať znovu",
      "submit": "ODOSLAŤ",
      "start": "Začať",
      "cancel": "Zrušiť",
      "next": "Ďalej",
      "yes": "Áno",
      "result": "Zobraziť výsledok"
    },
    "input": {
      "name": "Meno",
      "email": "E-mail",
      "email_confirmation": "Potvrďte e-mail",
      "dial_code": "Kód krajiny",
      "phone": "Vaše telefónne číslo",
      "field_required": "Povinný údaj",
      "phone_required": "Telefónne číslo je povinný údaj",
      "email_required": "E-mail je povinný údaj",
      "fullname_required": "Meno je povinný údaj"
    },
    "validation": {
      "required": "{attr} je Povinný údaj",
      "confirm": "Potvrdzovací {attr} sa nezhoduje"
    },
    "result_title": "Dôležité!",
    "finish_test": "Test skončil.",
    "finish_test_question": "Prajete si test urobiť znovu alebo ho odoslať na vyhodnotenie?",
    "start_over_question": "Určite chcete test skúsiť znovu?",
    "ready_to_test": "Ste pripravení začať test ?",
    "audio_instruction": "Vypočujte si audio a odpovedzte na otázku.",
    "et": {
      "instruction_1": "Test potrvá maximálne 30 minút.",
      "instruction_2": "Test sa skladá celkovo z 50 otázok.",
      "instruction_3": "Grafika a audio testu sa načítajú online, teda vyžadujú kvalitné pripojenie. Skôr ako sa do testu pustíte, skontrolujte si prosím internetové pripojenie.",
      "instruction_4": "Akonáhle stlačíte Začať, test je považovaný za zahájený.",
      "result": {
        "passed": [
          "Srdečne Vám gratulujeme, {fullname}! Úspešne ste absolvoval/a certifikáciu {level}.",
          "Certifikát PDF môžete získať kliknutím na ponuku/ikonu hamburgeru na hlavnej obrazovke a výberom možnosti \"MyCertificates\"."
        ],
        "review": [
          "Je nám ľúto, výsledok nestačil na certifikáciu {level}.",
          "Prosím zopakujte si navrhnuté aktivity. Potom test vykonajte znova."
        ],
        "failed": [
          "Je nám ľúto, výsledok na certifikáciu nestačil. Bohužiaľ sa dosiahol maximálny počet opakovaní certifikačného testu.",
          "Pre ďalšie informácie prosím kontaktujte svojho obchodného partnera."
        ],
        "auto_next": [
          "V tomto certifikačnom teste ste trikrát neuspeli. Môžete začať študovať ďalšiu úroveň a akonáhle neo pozná, že ste pripravení, môžete certifikačný test absolvovať znova. Dúfame, že ho zložíte. Potom dostanete certifikát. Veľa šťastia!",
          "Pre ďalšie informácie prosím kontaktujte svojho obchodného partnera."
        ],
        "ct_landing_failed": [
          "Je nám ľúto, výsledok na certifikáciu nestačil.",
          "Pre ďalšie informácie prosím kontaktujte svojho obchodného partnera."
        ]
      },
      "failed_test": "Test sa Vám bohužiaľ nepodaril.",
      "failed_test_description": "Nevzdávajte sa! Prejdite si opakovacie lekcie v neo Study a potom skúste test znovu.",
      "instruction_plus_1": "Test potrvá maximálne 20 minút.",
      "instruction_plus_2": "Test sa skladá celkovo z 25 otázok."
    },
    "pt": {
      "instruction_1": "Test potrvá maximálne 20 minút.",
      "instruction_2": "Tento test je adaptívny, tzn. že typ a počet prezentovaných otázok závisí na tom, ako sa  Vám v teste darí.",
      "instruction_3": "Grafika a audio testu sa načítajú online, teda vyžadujú kvalitné pripojenie. Skôr ako sa do testu pustíte, skontrolujte si prosím internetové pripojenie.",
      "instruction_4": "Test je možné urobiť až trikrát.",
      "result_correlation": "Porovnanie výsledku s inými testami - {level}",
      "cefr_chart": "Tabuľka úrovní ERR",
      "result": {
        "hide": "Ďakujeme, že ste absolvovali test. Ak chcete získať výsledky, kontaktujte svojho správcu.",
        "c1_pro": "Máte vynikajúci angličtinu! Kurzy na úrovni takmer rodeného hovorcu na neo ešte bohužiaľ nie sú k dispozícii. Keď budú, skontaktujeme vás.",
        "c1_pro_plus": "Gratulujeme, máte veľmi vysokú úroveň angličtiny! neo Vám teraz bohužiaľ nemôže ponúknuť kurz vyššej úrovne zakončený certifikáciou CEFR, máme však vynikajúci kurz C1-Bridge, ktorý Vám posilní plynulosť v angličtine a zvýši úspešnosť v štandardizovaných testoch najvyššej úrovne, ako je IELTS alebo TOEFL iBT."
      }
    },
    "test_time": "Test potrvá maximálne {minutes} minút.",
    "total_questions": "Test sa skladá celkovo z {total} otázok.",
    "error": {
      "invalid_credentials": "Neplatná identifikácia",
      "repeat_audio": "Audio  je možné vypočuť znovu iba raz",
      "start_over_retry": "Ľutujeme, test nie je možné zopakovať.",
      "connection_issue": "Skôr ako sa do testu pustíte, skontrolujte si prosím internetové pripojenie.",
      "student_already_registered": "Tento e-mail už existuje. Prosím použite inú e-mailovú adresu.",
      "timeout": "Váš čas vypršal",
      "email_submitted": "S touto e-mailovou adresou je už spojený výsledok testu neoAssessment"
    }
  },
  "es": {
    "level": "TU NIVEL",
    "button": {
      "start_test": "EMPEZAR EXAMEN",
      "start_over": "Empezar de nuevo",
      "submit": "ENVIAR",
      "start": "Empezar",
      "cancel": "Cancelar",
      "next": "Siguiente",
      "yes": "Sí",
      "result": "Mostrar resultado"
    },
    "input": {
      "name": "Nombre",
      "email": "Email",
      "email_confirmation": "Confirmar Email",
      "dial_code": "Código de país",
      "phone": "Tu número de teléfono",
      "field_required": "El campo es obligatorio.",
      "phone_required": "El número de teléfono es obligatorio.",
      "email_required": "El campo de Email es obligatorio.",
      "fullname_required": "El campo de Nombre es obligatorio."
    },
    "validation": {
      "required": "El campo de {attr} es obligatorio.",
      "confirm": "Tu {attr} de confirmación no coincide."
    },
    "result_title": "¡Importante!",
    "finish_test": "Tu examen ha terminado.",
    "finish_test_question": "¿Te gustaría empezar de nuevo? ¿O enviar el examen?",
    "start_over_question": "¿Estás seguro/a de que quieres reiniciar el examen?",
    "ready_to_test": "¿Estás listo/a  para tomar el examen?",
    "audio_instruction": "Reproduce el audio y responde la pregunta.",
    "et": {
      "instruction_1": "Tendrás un máximo de 30 minutos para realizar el examen.",
      "instruction_2": "El examen consta de un total de 50 preguntas.",
      "instruction_3": "Los gráficos y el audio del examen se cargan en línea y para cargarse requieren de una buena conexión a internet. Por favor, verifica tu conexión antes de comenzar.",
      "instruction_4": "Una vez que hagas clic en Empezar, el examen se considerará válido. Si sales del examen después de presionar Empezar o durante la mitad del mismo, se te calificará según la cantidad de elementos que respondiste correctamente antes de salir.",
      "result": {
        "passed": [
          "¡Felicidades, {fullname}! ¡Ha obtenido su certificado de {level}!",
          "Por favor, haz clic en el menú de \"hamburguesa\" en la pantalla principal y selecciona \"MyCertificates\" para obtener una copia en PDF de tu certificado."
        ],
        "review": [
          "Lo sentimos, pero su puntuación no fue lo suficientemente alta como para obtener su certificado de {level}.",
          "Complete los ejercicios de revisión sugeridos. Luego, vuelva a realizar la prueba."
        ],
        "failed": [
          "Lo sentimos, no pasó el examen de certificación. Ha alcanzado el número máximo de veces que puede realizar este examen.",
          "Póngase en contacto con support@nexgenenglishonline.co para obtener información."
        ],
        "auto_next": [
          "No aprobaste este Certification Test por tercera vez. Puedes comenzar el siguiente nivel hasta que neo te habilite nuevamente este examen. ¡Esperamos que lo pases y ganes tu certificado! Buena suerte.",
          "Póngase en contacto con support@nexgenenglishonline.co para obtener información."
        ],
        "ct_landing_failed": [
          "Lo sentimos, no pasó el examen de certificación.",
          "Póngase en contacto con support@nexgenenglishonline.co para obtener información."
        ]
      },
      "failed_test": "Lo sentimos, pero tu puntaje no fue lo suficientemente alto para ganar tu certificado de {level}.",
      "failed_test_description": "Por favor, completa las actividades de revisión sugeridas.",
      "instruction_plus_1": "Tendrás un máximo de 20 minutos para realizar el examen.",
      "instruction_plus_2": "El examen consta de un total de 25 preguntas."
    },
    "pt": {
      "instruction_1": "Tendrás un máximo de 20 minutos para realizar el examen.",
      "instruction_2": "Este es un examen adaptativo, por lo que el tipo y la cantidad de preguntas que se te hagan dependerá de tu desempeño.",
      "instruction_3": "Los gráficos y el audio del examen se cargan en línea y para cargarse requieren de una buena conexión a internet Por favor, verifica tu conexión antes de comenzar..",
      "instruction_4": "Puedes realizar la prueba hasta 3 veces.",
      "instruction_4_1": "Puede realizar la prueba 1 vez.",
      "result_correlation": "Correlaciones de resultados - {level}",
      "cefr_chart": "Tabla de niveles del MCER",
      "result": {
        "hide": "Gracias por tomar el Assessment Test. Por favor, contacte a su administrador para conocer sus resultados.",
        "c1_pro": "¡Tu Inglés es excelente! Nuestros cursos de inglés de nivel casi nativo aún no están disponibles en neo. ¡Nos pondremos en contacto contigo por correo electrónico cuando estén listos!",
        "c1_pro_plus": "¡Felicidades! Tu inglés es muy avanzado. Desafortunadamente, en este momento neo no puede ofrecerle un curso de Certificado MCER de nivel superior. Sin embargo, tenemos un excelente curso C1-Bridge para ayudarlo a fortalecer su fluidez en inglés y mejorar aún más su capacidad para tener éxito en los exámenes estandarizados de alto nivel como el IELTS o el iBT."
      }
    },
    "test_time": "Tendrás un máximo de {minutes} minutos para realizar el examen.",
    "total_questions": "El examen consta de un total de {total} preguntas.",
    "error": {
      "invalid_credentials": "Credenciales inválidas.",
      "repeat_audio": "Solo puedes repetir el audio una vez.",
      "start_over_retry": "Lo sentimos, la prueba no se puede repetir.",
      "connection_issue": "Por favor, verifica tu conexión antes de comenzar.",
      "student_already_registered": "Este correo ya esta registrado, por favor utiliza otro correo electrónico.",
      "timeout": "Tu tiempo se ha acabado",
      "email_submitted": "Ya existe un resultado de la prueba neoAssessment asociado a este correo electrónico"
    }
  },
  "th": {
    "level": "ระดับของคุณ",
    "button": {
      "start_test": "เริ่มต้นทำข้อสอบ",
      "start_over": "เริ่มต้นใหม่",
      "submit": "ยืนยัน",
      "start": "เริ่ม",
      "cancel": "ยกเลิก",
      "next": "ถัดไป",
      "yes": "ใช่",
      "result": "แสดงผลลัพธ์"
    },
    "input": {
      "name": "ชื่อ",
      "email": "อีเมล์",
      "email_confirmation": "ยืนยันอีเมล์",
      "dial_code": "รหัสประเทศ",
      "phone": "เบอร์โทรศัพท์ของคุณ",
      "field_required": "จำเป็นต้องกรอกข้อมูล",
      "phone_required": "จำเป็นต้องกรอกหมายเลขโทรศัพท์",
      "email_required": "จำเป็นต้องกรอกอีเมล์",
      "fullname_required": "จำเป็นต้องกรอกชื่อ"
    },
    "validation": {
      "required": "{attr} จำเป็นต้องกรอกข้อมูล",
      "confirm": "{attr} อีเมล์ยืนยันของคุณไม่ตรงกัน"
    },
    "result_title": "สำคัญ!",
    "finish_test": "คุณทำข้อสอบเสร็จสิ้นแล้ว",
    "finish_test_question": "คุณต้องการที่จะทำข้อสอบอีกครั้งหรือส่งคำตอบ",
    "start_over_question": "คุณแน่ใจที่จะทำข้อสอบอีกครั้งใช่ไหม",
    "ready_to_test": "คุณพร้อมที่จะทำข้อสอบหรือไม่",
    "audio_instruction": "กดเพื่อเล่นเสียงและตอบคำถาม",
    "et": {
      "instruction_1": "คุณมีเวลาทำข้อสอบสูงสุด 30 นาที",
      "instruction_2": "ข้อสอบประกอบไปด้วย 50 คำถาม",
      "instruction_3": "ระบบโหลดกราฟฟิคและเสียงในข้อสอบผ่านทางออนไลน์ ดังนั้นจึงควรเชื่อมต่อกับอินเตอร์เน็ตที่มีความเสถียร. กรุณาตรวจสอบการเชื่อมต่อก่อนเริ่มทำข้อสอบ",
      "instruction_4": "เมื่อคุณคลิก 'เริ่มต้น' จะนับว่าเป็นการเริ่มทำข้อสอบทันที",
      "result": {
        "passed": [
          "ยินดีด้วย, {fullname}! คุณได้รับประกาศนียบัตรรับรองผล {level}!",
          "กดเลือกเมนูชื่อว่า Hamburger (แฮมเบอร์เกอร์) ในหน้าหลักและเลือก Mycertificates (ใบประกาศนียบัตรของฉัน) เพื่อรับใบประกาศนียบัตรในรูปแบบไฟล์ PDF."
        ],
        "review": [
          "ขออภัย คะแนนของคุณยังไม่ผ่านเกณฑ์ที่จะได้รับใบประกาศนียบัตรรับรองผล {level}",
          "โปรดทำแบบฝึกบทหัดทบทวนที่ทางเราแนะนำ และทำแบบทดสอบอีกครั้งตามกำหนด"
        ],
        "failed": [
          "ขออภัย คุณไม่ผ่านแบบทดสอบรับรองผล และคุณทำข้อสอบถึงจำนวนครั้งสูงสุดแล้ว",
          "กรุณาติดต่อ support@nexgenenglishonline.co เพื่อสอบถามข้อมูลเพิ่มเติม"
        ],
        "auto_next": [
          "คุณทำข้อสอบวัดระดับไม่ผ่านครบสามครั้ง คุณสามารถเริ่มเรียนในระดับถัดไปได้ เมื่อ neo เชื่อว่าคุณมีความพร้อม คุณสามารถทำข้อสอบวัดระดับได้อีกครั้ง เราหวังว่าคุณทำได้และได้รับประกาศนียบัครในระดับของคุณ ขอให้โชคดี",
          "กรุณาติดต่อ support@nexgenenglishonline.co เพื่อสอบถามข้อมูลเพิ่มเติม"
        ],
        "ct_landing_failed": [
          "ขออภัย คุณไม่ผ่านแบบทดสอบรับรองผล",
          "กรุณาติดต่อ support@nexgenenglishonline.co เพื่อสอบถามข้อมูลเพิ่มเติม"
        ]
      },
      "failed_test": "เสียใจด้วย แต่คะแนนของคุณไม่มากพอที่จะได้รับประกาศนียบัตรระดับ {level}",
      "failed_test_description": "กรุณาทบทวนบทเรียนที่แนะนำ",
      "instruction_plus_1": "Yคุณมีเวลาทำข้อสอบสูงสุด 20 นาที",
      "instruction_plus_2": "ข้อสอบประกอบไปด้วย 25 คำถาม"
    },
    "pt": {
      "instruction_1": "คุณมีเวลาทำข้อสอบสูงสุด 20 นาที",
      "instruction_2": "ข้อสอบเป็นแบบปรับเหมาะ ดังนั้นประเภทและจำนวนข้อสอบจะขึ้นอยู่กับความสามารถของคุณ",
      "instruction_3": "ระบบโหลดกราฟฟิคและเสียงในข้อสอบผ่านทางออนไลน์ ดังนั้นจึงควรเชื่อมต่อกับอินเตอร์เน็ตที่มีความเสถียร. กรุณาตรวจสอบการเชื่อมต่อก่อนเริ่มทำข้อสอบ",
      "instruction_4": "คุณสามารถทำข้อสอบได้ 3 ครั้ง",
      "instruction_4_1": "คุณสามารถทำข้อสอบได้ 1 ครั้ง",
      "result_correlation": "ผลสอบเทียบเคียงกับข้อสอบอื่น - {level}",
      "cefr_chart": "แผนผังแสดงระดับ CEFR",
      "result": {
        "hide": "ขอบคุณที่ทำการทดสอบกับเรา โปรดติดต่อผู้ดูแลระบบของคุณเพื่อทราบผลการสอบ",
        "c1_pro": "ระดับทักษะภาษาอังกฤษของคุณใกล้เคียงกับเจ้าของภาษาซึ่งยอดเยี่ยมมาก ซึ่งถือเป็นระดับที่สูงสุดของเรา หากมีคอร์สที่สูงกว่าระดับของคุณเปิดทางเราจะส่งอีเมล์หาคุณเมื่อคอร์สพร้อมใช้งาน!",
        "c1_pro_plus": "ยินดีด้วย! ทักษะภาษาอังกฤษของคุณใกล้เคียงเจ้าของภาษา ซึ่งยอดเยี่ยมมาก แต่ทาง neo ยังไม่สามารถเปิดคอร์ส CEFR ที่ระดับสูงกว่าความสามารถของคุณได้ อย่างไรก็ตาม เราขอนำเสนอคอร์ส C1-Bridge ที่จะช่วยพัฒนาความคล่องแคล่วทางภาษาอังกฤษของคุณ และส่งเสริมความสามารถให้คุณประสบความสำเร็จในการทดสอบมาครฐานระดับสูง เช่น IELTS หรือ iBT"
      }
    },
    "test_time": "คุณมีเวลาทำข้อสอบสูงสุด {minutes} นาที",
    "total_questions": "ข้อสอบประกอบไปด้วย {total} คำถาม",
    "error": {
      "invalid_credentials": "ข้อมูลไม่ถูกต้อง",
      "repeat_audio": "คุณสามารถฟังเสียงซ้ำได้เพียงครั้งเดียว",
      "start_over_retry": "ขออภัย ไม่สามารถทดสอบซ้ำได้",
      "connection_issue": "กรุณาตรวจสอบการเชื่อมต่อก่อนเริ่มทำข้อสอบ",
      "student_already_registered": "อีเมล์นี้ใช้ในการลงทะเบียนแล้ว โปรดใช้อีเมล์อื่น",
      "timeout": "เวลาของคุณหมดแล้ว",
      "email_submitted": "มีผลการทดสอบ neoAssessment ที่เชื่อมโยงกับอีเมลนี้แล้ว"
    }
  },
  "tr": {
    "level": "Sınav Sonucunuz",
    "button": {
      "start_test": "SINAVA BAŞLA",
      "start_over": "Yeniden Başla",
      "submit": "SONUCU TESLİM ET",
      "start": "Başla",
      "cancel": "İptal",
      "next": "Sonraki",
      "yes": "Evet",
      "result": "Sonucu Göster"
    },
    "input": {
      "name": "Adınız",
      "email": "Eposta Adresiniz",
      "email_confirmation": "Eposta Adresiniz (tekrar)",
      "dial_code": "Ülke Kodu",
      "phone": "Telefon Numaranız",
      "field_required": "Bu bölüm doldurulmalıdır.",
      "phone_required": "Telefon numaranız yazılmalıdır.",
      "email_required": "Eposta adresiniz yazılmalıdır.",
      "fullname_required": "Adınız yazılmalıdır."
    },
    "validation": {
      "required": "{attr} Bu bölüm doldurulmalıdır.",
      "confirm": "{attr} uyuşmuyor."
    },
    "result_title": "Önemli!",
    "finish_test": "Sınavınız bitmiştir.",
    "finish_test_question": "Sınav sonucunu teslim edebilir veya yeniden başlayabilirsiniz.",
    "start_over_question": "Yeniden başlamak istediğinize emin misiniz?",
    "ready_to_test": "Sınava başlamaya hazır mısınız?",
    "audio_instruction": "Sesi sadece bir defa tekrarlayabilirsiniz.",
    "et": {
      "instruction_1": "Sınav en fazla 30 dakikada bitirilmelidir.",
      "instruction_2": "Bu sınavda toplam 50 soru bulunmaktadır.",
      "instruction_3": "Sınavın görüntü ve sesleri online olarak yüklenmekte olduğundan internet bağlantınızın iyi olması gerekmektedir. Lütfen, sınava başlamadan önce bağlantınızı kontrol edin.",
      "instruction_4": "Başla komutunu verdiğinizde sınav geçerli sayılacaktır.",
      "result": {
        "passed": [
          "Tebrikler, {fullname}! {level} düzeyindeki sertifikanızı almaya hak kazandınız.",
          "Ana ekrandaki Hamburger menu üzerinden \"MyCertificates\" bölümünü tıklayarak CEFR Sertifikanızın bir PDF kopyasını indirebilirsiniz."
        ],
        "review": [
          "Üzgünüz! Sınav sonucunuz {level} düzeyindeki sertifikanızı almak için yeterli değil.",
          "Lütfen, önerilen üniteleri yeniden çalışın. Çalıştıktan sonra yeniden sınava girebilirsiniz."
        ],
        "failed": [
          "Üzgünüz! Sınav sonucunuz Sertifikasyon testini geçmenize yetmedi. Maalesef, Sertikasyon Testi için alınabilecek en fazla test sayısını da geçtiniz.",
          "Lütfen destek@dyned.com.tr ile iletişime geçiniz."
        ],
        "auto_next": [
          "Maalesef, Sertifikasyon Sınavında üç kez başarısız oldunuz. Bir sonraki kursa devam ederseniz, yapay zeka hazır olduğunuzu değerlendirdiğinde geçemediğiniz Sertifikasyon Sınavını açacaktır. Tekrar girebilir, ilerlemiş olduğunuz için sınavı geçebilir ve sertifikanızı alabilisiniz.",
          "Lütfen destek@dyned.com.tr ile iletişime geçiniz."
        ],
        "ct_landing_failed": [
          "Üzgünüz! Sınav sonucunuz Sertifikasyon testini geçmenize yetmedi.",
          "Lütfen destek@dyned.com.tr ile iletişime geçiniz."
        ]
      },
      "failed_test": "Üzgünüz! Sınav sonucunuz {level} düzeyindeki sertifikanızı almak için yeterli değil.",
      "failed_test_description": "Lütfen, önerilen üniteleri yeniden çalışın.",
      "instruction_plus_1": "Sınav en fazla 20 dakikada bitirilmelidir.",
      "instruction_plus_2": "Bu sınavda toplam 25 soru bulunmaktadır."
    },
    "pt": {
      "instruction_1": "Sınav en fazla 20 dakikada bitirilmelidir.",
      "instruction_2": "Bu sınav soru sayısını ve zorluk derecesini sınavı yapan kişiye göre uyarlamaktadır. Herkesin sınavı farklı olacaktır.",
      "instruction_3": "Sınavın görüntü ve sesleri online olarak yüklenmekte olduğundan internet bağlantınızın iyi olması gerekmektedir. Lütfen, sınava başlamadan önce bağlantınızı kontrol edin.",
      "instruction_4": "Yöneticiniz bu sınavı üç defaya kadar tekrarlama olanağını size sunabilir.",
      "result_correlation": "Sınav Denklikleri - {level}",
      "cefr_chart": "CEFR Düzeyi Tablosu",
      "result": {
        "hide": "Düzey Belirleme Sınavını aldığınız için teşekkür ederiz. Sonuçları sadece yöneticiler görebilmektedir.",
        "c1_pro": "İngilizceniz mükemmel! Ana dil seviyesindeki İngilizce kurslarımız henüz neo'da sunulmamaktadır. Hazır olduklarında sizinle e-posta yoluyla iletişime geçeceğiz!",
        "c1_pro_plus": "Tebrikler! İngilizceniz çok gelişmiş. Ne yazık ki, şu anda neo size daha yüksek seviyeli bir CEFR Sertifikası kursu sunamaz. Ancak, İngilizce akıcılığınızı güçlendirmenize ve IELTS veya iBT gibi yüksek seviyeli standart testlerde başarılı olma becerinizi daha da geliştirmenize yardımcı olacak mükemmel bir C1-Bridge kursumuz var."
      }
    },
    "test_time": "Sınav en fazla {minutes} dakikada bitirilmelidir.",
    "total_questions": "Bu sınavda toplam {total} soru bulunmaktadır.",
    "error": {
      "invalid_credentials": "Yetersiz bilgi!",
      "repeat_audio": "Sesi sadece bir defa tekrarlayabilirsiniz.",
      "start_over_retry": "Üzgünüz, test tekrar edilemez.",
      "connection_issue": "Lütfen, sınava başlamadan önce bağlantınızı kontrol edin.",
      "student_already_registered": "Email already registered, please use another email address",
      "timeout": "Süren doldu",
      "email_submitted": "Bu e-posta adresine ait zaten bir neoAssessment test sonucu mevcut"
    }
  },
  "cn": {
    "level": "你当前所在级别",
    "button": {
      "start_test": "开始测试",
      "start_over": "重新测试",
      "submit": "提交",
      "start": "开始",
      "cancel": "取消",
      "next": "下一题",
      "yes": "确认",
      "result": "显示结果"
    },
    "input": {
      "name": "姓名",
      "email": "邮箱",
      "email_confirmation": "邮箱确认",
      "dial_code": "国家代码",
      "phone": "手机号码",
      "field_required": "此处必填",
      "phone_required": "手机号码必填",
      "email_required": "邮箱必填",
      "fullname_required": "真实中文名必填"
    },
    "validation": {
      "required": "此处必填",
      "confirm": "邮箱不一致"
    },
    "result_title": "重要！",
    "finish_test": "测试结束",
    "finish_test_question": "重新测试还是提交本次测试结果？",
    "start_over_question": "确认要重新测试吗？",
    "ready_to_test": "确认开始测试吗?",
    "audio_instruction": "听音频后作答",
    "et": {
      "instruction_1": "测试时间最长为30分钟.",
      "instruction_2": "本次测试一共有50道题目.",
      "instruction_3": "测试中的图片和音频等素材需要实时下载，请在良好的网络环境下进行测试。请在开始测试前确保网络环境良好。",
      "instruction_4": "一旦点击“开始”按钮，测试即被视为有效. 如果在点击“开始”按钮后或在测试中间退出，系统会根据已正确完成的题目来判定成绩.",
      "result": {
        "passed": [
          "祝贺您, {fullname}！您获得了 {level} 级别的证书！",
          "请点击主屏幕左上角的菜单栏，选择“我的证书”，以获取您PDF格式的证书。"
        ],
        "review": [
          "非常抱歉，您未能通过 {level} 级别的结业测试并获得该级别证书。",
          "请完成系统推送给您的复习课程并重新进行该级别的结业测试。"
        ],
        "failed": [
          "抱歉，您已用尽该级别结业测试的三次机会，仍未通过该测试。",
          "请联系support@nexgenenglishonline.co 获得更多信息和帮助。"
        ],
        "auto_next": [
          "很抱歉，您已三次未通过结业测试。但是您可以继续学习下一课程。Neo将在您达到测试要求时，再一次打开结业测试。我们希望您能通过并获得证书。祝您好运。",
          "请联系support@nexgenenglishonline.co 获得更多信息和帮助。"
        ],
        "ct_landing_failed": [
          "抱歉，您已用尽该级别结业测试的三次机会。",
          "请联系support@nexgenenglishonline.co 获得更多信息和帮助。"
        ]
      },
      "failed_test": "抱歉，您没有通过该测试。",
      "failed_test_description": "别放弃！请完成neo Study App里的复习课程并再次进行测试。",
      "instruction_plus_1": "测试时间最长为20分钟。",
      "instruction_plus_2": "本次测试一共有25道题目。"
    },
    "pt": {
      "instruction_1": "测试时间最长为20分钟。",
      "instruction_2": "此测试为自适应测试，测试题目的难度和数量都将随着你的答题表现而变化。",
      "instruction_3": "测试中的图片和音频等素材需要实时下载，请在良好的网络环境下进行测试。请在开始测试前确保网络环境良好。",
      "instruction_4": "你最多有3次参加测试的机会。",
      "instruction_4_1": "你有1次参加测试的机会。",
      "result_correlation": "级别对照 - {level}",
      "cefr_chart": "CEFR级别对照",
      "result": {
        "c1_pro": "您的英语太棒了！neo暂时还没有发布符合您级别的接近母语水平的课程。等课程发布后，我们将通过邮件和您联系。",
        "c1_pro_plus": "恭喜您，您的英语水平非常高！非常抱歉，目前neo还没有发布更高级别的CEFR课程。但是，neo C1-Bridge 级别的课程会帮助您提升您的语言流利度，并助力您在雅思、托福等国际标准化英语测试中取得好成绩。"
      }
    },
    "test_time": "测试时间最长为{minutes}分钟。",
    "total_questions": "本次测试一共有{total}道题目。",
    "error": {
      "invalid_credentials": "必填项未完成",
      "repeat_audio": "音频只能重听一次",
      "start_over_retry": "抱歉，测试无法重复。",
      "connection_issue": "请在开始测试前确保网络环境良好.",
      "student_already_registered": "您的邮件地址已被注册，请更换邮件地址。",
      "timeout": "你的时间到了",
      "email_submitted": "此邮箱已关联一个 neoAssessment 测试结果"
    }
  },
  "jp": {
    "level": "あなたのレベル",
    "button": {
      "start_test": "テストを開始",
      "start_over": "テストをやり直す",
      "submit": "提出",
      "start": "スタート",
      "cancel": "キャンセル",
      "next": "次へ",
      "yes": "はい",
      "result": "結果を表示"
    },
    "input": {
      "name": "お名前",
      "email": "Eメールアドレス",
      "email_confirmation": "Eメールアドレス (確認用)",
      "dial_code": "国番号",
      "phone": "電話番号",
      "field_required": "この項目は必須項目です。",
      "phone_required": "電話番号を入力してください",
      "email_required": "Eメールアドレスを入力してください",
      "fullname_required": "お名前を入力してください"
    },
    "validation": {
      "required": "{attr} 必須項目です。",
      "confirm": "Eメールアドレスが一致しません。"
    },
    "result_title": "重要！",
    "finish_test": "テストはこれで終わりです。",
    "finish_test_question": "テストを最初からやり直すには「テストをやり直す」を、これで終了するには「提出」をクリックしてください。",
    "start_over_question": "本当にテストを最初からやり直しますか?",
    "ready_to_test": "テスト受ける準備はよろしいですか?",
    "audio_instruction": "音声を再生し、問題に解答してください。",
    "et": {
      "instruction_1": "テストの制限時間は30分です",
      "instruction_2": "テストは全50問です",
      "instruction_3": "テストの画像や音声はオンラインから配信されるので、安定したインターネット接続が必要です。テストを開始する前に通信状況が良好かどうか確認してください。",
      "instruction_4": "「スタート」をクリックするとテストが開始されます。",
      "result": {
        "passed": [
          "おめでとうございます, {fullname}！{level}の認定書を取得しました！",
          "xホーム画面のハンバーガーメニューをクリックし、「MyCertificates」を選択して認定書のPDFコピーを取得してください。"
        ],
        "review": [
          "残念ですが、テスト結果は{level}には届きませんでした。",
          "提示されるレッスンを復習した後、再テストを受けてください。"
        ],
        "failed": [
          "残念ですが、Certification Test（レベル到達確認テスト）に合格できませんでした。またテストの受験上限回数に達してしまいました。",
          "恐れ入りますが、 support@nexgenenglishonline.co までご連絡の上ご相談ください。"
        ],
        "auto_next": [
          "残念ながら、Certification Testに3回不合格となりました。まずは次のコースの学習を進めてください。neoが準備が整ったと判断したら再度このCertification Testを受けることができます。合格し、認定書を取得できることを願っています。がんばって！",
          "恐れ入りますが、 support@nexgenenglishonline.co までご連絡の上ご相談ください。"
        ],
        "ct_landing_failed": [
          "残念ですが、Certification Test（レベル到達確認テスト）に合格できませんでした。",
          "恐れ入りますが、 support@nexgenenglishonline.co までご連絡の上ご相談ください。"
        ]
      },
      "failed_test": "残念ながら合格できませんでした。",
      "failed_test_description": "あきらめないで！neo StudyアプリでReview lessonを復習してから再挑戦してください。",
      "instruction_plus_1": "テストの制限時間は20分です。",
      "instruction_plus_2": "テストは全25問です。"
    },
    "pt": {
      "instruction_1": "テストの制限時間は20分です。",
      "instruction_2": "レベルが判定された時点でテストは終了となります。そのため人によってテストにかかる時間や出題数が異なります。",
      "instruction_3": "テストの画像や音声はオンラインから配信されるので、安定したインターネット接続が必要です。テストを開始する前に通信状況が良好かどうか確認してください。",
      "instruction_4": "テストは最大３回まで受けられます。",
      "instruction_4_1": "テストは１回のみ受けられます。",
      "result_correlation": "他テストとの相関 - {level}",
      "cefr_chart": "CEFRレベルチャート",
      "result": {
        "hide": "アセスメントテストを受けていただきありがとうございました。結果については、管理者へお問い合わせください。",
        "c1_pro": "このレベルはまだneoでは対応できておりません。準備が出来次第Eメールにてご連絡いたします。",
        "c1_pro_plus": "大変申し訳ございませんが、現在neoはハイレベルのコースをご用意できておりません。代わりに流暢さをより強化し、IELTSやiBTのような上級者向けの共通テスト対策に役立つC1-Bridgeコースがあります。"
      }
    },
    "test_time": "テストの制限時間は{minutes}分です。",
    "total_questions": "テストは全{total}問です。",
    "error": {
      "invalid_credentials": "無効な認証情報",
      "repeat_audio": "音声のリピート再生は１回だけできます",
      "start_over_retry": "申し訳ありませんが、テストを繰り返すことはできません。",
      "connection_issue": "テストを始める前に通信状況が良好かどうか確認してください。",
      "student_already_registered": "このEメールアドレスはすでに使用されています。違うEメールアドレスにしてください。",
      "timeout": "あなたの持ち時間は終わりです",
      "email_submitted": "このメールアドレスにはすでに neoAssessment のテスト結果があります"
    }
  },
  "br": {
    "level": "Seu nivel",
    "button": {
      "start_test": "Iniciar Teste",
      "start_over": "Recomeçar",
      "submit": "Enviar",
      "start": "Começar",
      "cancel": "Cancelar",
      "next": "Próximo",
      "yes": "Sim",
      "result": "Mostrar resultado"
    },
    "input": {
      "name": "Nome Completo",
      "email": "E-mail",
      "email_confirmation": "Confirme Seu E-mail",
      "dial_code": "Código do País",
      "phone": "Seu número de celular",
      "field_required": "Este campo é obrigatório",
      "phone_required": "O número de telefone é obrigatório",
      "email_required": "O campo de e-mail é obrigatório",
      "fullname_required": "O campo \"nome completo\" é obrigatório"
    },
    "validation": {
      "required": "{attr} Campo obrigatório",
      "confirm": "{attr} Confirmação não corresponde"
    },
    "result_title": "Importante!",
    "finish_test": "Seu teste está concluido!",
    "finish_test_question": "Você gostaria de começar de novo ou enviá-lo?",
    "start_over_question": "Tem certeza de que deseja recomeçar?",
    "ready_to_test": "Você está pronto para fazer o teste?",
    "audio_instruction": "Reproduza o áudio e responda à pergunta",
    "et": {
      "instruction_1": "Você terá no máximo 30 minutos para fazer o teste.",
      "instruction_2": "O teste é composto por um total de 50 questões.",
      "instruction_3": "Os gráficos e o áudio do Teste são carregados online e requerem uma boa conexão com a Internet para serem carregados. Verifique sua conexão antes de começar.",
      "instruction_4": "Depois de clicar em Iniciar, o teste será considerado válido. Se você sair do teste depois de pressionar iniciar ou durante o teste, você será pontuado com base em quantos itens você respondeu corretamente antes de sair.",
      "result": {
        "passed": [
          "Parabéns, {fullname}! Você ganhou seu certificado {level}!.",
          "Por favor, clique no menu \"hambúrguer\" na tela principal e selecione \"MyCertificates\" para obter uma cópia em PDF do seu certificado."
        ],
        "review": [
          "Lamentamos, mas sua pontuação não foi alta o suficiente para ganhar seu certificado {level}.",
          "Por favor, complete os exercícios de revisão sugeridos. Depois, faça o teste novamente."
        ],
        "failed": [
          "Desculpe, você não passou no Teste de Certificação. Você atingiu o número máximo de vezes que pode fazer o Teste de Certificação.",
          "Entre em contato com contato@kod-educ.com para obter informações."
        ],
        "auto_next": [
          "Você falhou neste Certification Test três vezes. Você pode começar o próximo nível até que o neo permita o exame novamente. Esperamos que você passe e ganhe seu certificado! Boa sorte.",
          "Entre em contato com contato@kod-educ.com para obter informações."
        ],
        "ct_landing_failed": [
          "Desculpe, você não passou no Teste de Certificação.",
          "Entre em contato com contato@kod-educ.com para obter informações."
        ]
      },
      "failed_test": "Desculpe, você não passou no teste.",
      "failed_test_description": "Não desista! Complete a lição de revisão no aplicativo neo study e faça o teste novamente.",
      "instruction_plus_1": "Você terá no máximo 20 minutos para fazer o teste.",
      "instruction_plus_2": "O teste consiste em um total de 25 perguntas."
    },
    "pt": {
      "instruction_1": "Você terá no máximo 20 minutos para fazer o teste.",
      "instruction_2": "Este é um teste adaptativo, portanto, o tipo e o número de perguntas que serão feitas dependerão do seu desempenho.",
      "instruction_3": "Os gráficos e o áudio do Teste são carregados online e requerem uma boa conexão com a Internet para serem carregados. Verifique sua conexão antes de começar.",
      "instruction_4": "Você pode fazer o teste até 3 vezes",
      "instruction_4_1": "Você pode fazer o teste 1 vez",
      "result_correlation": "Correlação de resultados - {level}",
      "cefr_chart": "Tabela de Nível CEFR",
      "result": {
        "c1_pro": "Seu inglês é excelente! Nossos cursos de inglês de nível avançado ainda não estão disponíveis no neo. Entraremos em contato por e-mail quando estiverem disponíveis!",
        "c1_pro_plus": "Parabéns! Seu inglês é muito avançado. Infelizmente, neste momento, o neo não pode oferecer a você um curso de certificado CEFR de nível superior. No entanto, temos um excelente curso C1-Bridge para ajudá-lo a fortalecer sua fluência em inglês e aprimorar ainda mais sua capacidade de obter sucesso em testes padronizados de alto nível, como o IELTS ou o iBT."
      }
    },
    "test_time": "Você terá no máximo {minutes} minutos para fazer o teste.",
    "total_questions": "O teste consiste em um total de {total} perguntas.",
    "error": {
      "invalid_credentials": "Credenciais inválidas",
      "repeat_audio": "Você só pode repetir o áudio uma vez.",
      "start_over_retry": "Desculpe, o teste não pode ser repetido.",
      "connection_issue": "Verifique sua conexão antes de começar.",
      "student_already_registered": "E-mail já cadastrado, por favor use outro endereço de e-mail.",
      "timeout": "Seu tempo acabou",
      "email_submitted": "Já existe um resultado de teste neoAssessment associado a este e-mail"
    }
  },
  "vn": {
    "level": "Trình độ của bạn",
    "button": {
      "start_test": "Bắt đầu bài kiểm tra",
      "start_over": "Bắt đầu lại",
      "submit": "Nộp bài",
      "start": "Bắt đầu",
      "cancel": "Hủy",
      "next": "Kế tiếp",
      "yes": "Đồng ý",
      "result": "Hiển thị kết quả"
    },
    "input": {
      "name": "Tên",
      "email": "E-mail",
      "email_confirmation": "Xác nhận e-mail",
      "dial_code": "Mã vùng quốc gia của bạn",
      "phone": "Số điện thoại của bạn",
      "field_required": "Thông tin cần được xác nhận",
      "phone_required": "Yêu cầu nhập số điện thoại",
      "email_required": "Yêu cầu nhập địa chỉ e-mail",
      "fullname_required": "Yêu cầu nhập đầy dủ tên họ"
    },
    "validation": {
      "required": "{attr} Thông tin cần được xác nhận",
      "confirm": "{attr} Xác nhận không khớp"
    },
    "result_title": "Quan trọng!",
    "finish_test": "Bài kiểm tra của bạn đã kết thúc.",
    "finish_test_question": "Bạn có muốn làm lại bài kiểm tra hoặc gửi bài kiểm tra bây giờ?",
    "start_over_question": "Bạn có chắc chắn muốn làm lại không?",
    "ready_to_test": "Bạn đã sẵn sàng để làm bài kiểm tra chưa?",
    "audio_instruction": "Hãy bắt đầu nghe và trả lời câu hỏi",
    "et": {
      "instruction_1": "Bạn sẽ có tối đa 30 phút để làm bài kiểm tra.",
      "instruction_2": "Bài kiểm tra bao gồm tổng cộng 50 câu hỏi.",
      "instruction_3": "Đồ họa và âm thanh trong Bài kiểm tra được tải trực tuyến và yêu cầu kết nối Internet tốt để tải. Vui lòng kiểm tra kết nối của bạn trước khi bạn bắt đầu.",
      "instruction_4": "Khi bạn nhấp vào Bắt đầu, bài kiểm tra sẽ được coi là hợp lệ. Nếu bạn thoát khỏi bài kiểm tra sau khi nhấn bắt đầu hoặc trong khi đang làm bài giữa chừng, bạn sẽ được tính điểm dựa trên số mục bạn đã trả lời đúng trước khi nhấn thoát khoải bài kiểm tra.",
      "result": {
        "passed": [
          "Chúc mừng, {fullname}! Bạn đã giành được {level} Chứng chỉ!",
          "Vui lòng nhấp vào biểu tượng menu và chọn \"MyCertificates\" để nhận bản sao PDF chứng chỉ của bạn."
        ],
        "review": [
          "Rất tiếc, điểm của bạn không đủ cao để nhận được {level} chứng chỉ.",
          "Hãy hoàn thành các bài tập ôn tập gợi ý. Sau đó, làm bài kiểm tra lại."
        ],
        "failed": [
          "Rất tiếc, bạn đã không vượt qua Bài kiểm tra chứng nhận. Bạn đã đạt đến số lần tối đa có thể tham gia Bài kiểm tra chứng chỉ.",
          "Vui lòng liên hệ support@nexgenenglishonline.co để biết thêm thông tin."
        ],
        "auto_next": [
          "Bạn đã trượt Bài kiểm tra chứng chỉ này ba lần. Bây giờ bạn có thể bắt đầu khóa học tiếp theo. Khi neo tin rằng bạn đã sẵn sàng, bạn có thể thực hiện lại Bài kiểm tra chứng nhận này. Chúng tôi hy vọng bạn vượt qua bài kiếm tra này. Sau đó, bạn sẽ nhận được Giấy chứng nhận của mình. Chúc may mắn.",
          "Vui lòng liên hệ support@nexgenenglishonline.co để biết thêm thông tin."
        ],
        "ct_landing_failed": [
          "Xin lỗi, bạn đã không vượt qua Bài kiểm tra chứng nhận.",
          "Vui lòng liên hệ support@nexgenenglishonline.co để biết thêm thông tin."
        ]
      },
      "failed_test": "Xin lỗi, bạn đã không vượt qua bài kiểm tra.",
      "failed_test_description": "Đừng bỏ cuộc! Hoàn thành bài ôn tập trong Ứng dụng học mới và làm lại bài kiểm tra.",
      "instruction_plus_1": "Bạn sẽ có tối đa 20 phút để làm bài kiểm tra.",
      "instruction_plus_2": "Bài kiểm tra có tổng cộng 25 câu hỏi."
    },
    "pt": {
      "instruction_1": "Bạn sẽ có tối đa 20 phút để làm bài kiểm tra.",
      "instruction_2": "Đây là một bài kiểm tra thích ứng, vì vậy loại và số lượng câu hỏi bạn được hỏi sẽ phụ thuộc vào hiệu suất của bạn.",
      "instruction_3": "Đồ họa và âm thanh trong Bài kiểm tra được tải trực tuyến và yêu cầu kết nối Internet tốt để tải. Vui lòng kiểm tra kết nối của bạn trước khi bạn bắt đầu.",
      "instruction_4": "Bạn có thể làm bài kiêm tra tối đa 3 lần.",
      "instruction_4_1": "Bạn có thể làm bài kiểm tra 1 lần.",
      "result_correlation": "Tương quan kết quả - {level}",
      "cefr_chart": "Biểu đồ cấp độ CEFR",
      "result": {
        "c1_pro": "Tiếng Anh của bạn thật xuất sắc! Các khóa học tiếng Anh trình độ cho người bản ngữ của chúng tôi chưa có trên neo. Chúng tôi sẽ liên hệ với bạn qua email khi khóa học này ra mắt!",
        "c1_pro_plus": "Chúc mừng! Tiếng Anh của bạn rất tốt. Rất tiếc, tại thời điểm này, neo không thể cung cấp cho bạn khóa học Chứng chỉ CEFR cấp cao hơn. Tuy nhiên, chúng tôi có một khóa học C1-Bridge rất tuyệt vời để giúp bạn củng cố khả năng nói tiếng Anh một cách lưu loát và nâng cao khả năng thành công của bạn trong các bài kiểm tra tiêu chuẩn cấp độ cao như IELTS hoặc iBT."
      }
    },
    "test_time": "Bạn sẽ có tối đa {minutes} phút để làm bài kiểm tra.",
    "total_questions": "Bài kiểm tra bao gồm tổng cộng {total} câu hỏi.",
    "error": {
      "invalid_credentials": "Thông tin không hợp lệ.",
      "repeat_audio": "Bạn chỉ có thể nghe lại một lần.",
      "start_over_retry": "Rất tiếc, bạn không thể bắt đầu lại bài kiểm tra.",
      "connection_issue": "Vui lòng kiểm tra kết nối của bạn trước khi bạn bắt đầu.",
      "student_already_registered": "Email này đã được sử dụng, vui lòng sử dụng địa chỉ email khác.",
      "timeout": "Thời gian làm bài kiểm tra của bạn đã hết.",
      "email_submitted": "Đã có kết quả kiểm tra neoAssessment liên kết với email này"
    }
  },
  "kg": {
    "level": "Сиздин деңгээлиңизl",
    "button": {
      "start_test": "Тестти баштоо",
      "start_over": "Кайрадан баштоо",
      "submit": "Тесттин натыйжасын жиберүү",
      "start": "Баштоо",
      "cancel": "Жоюу",
      "next": "Кийинки",
      "yes": "Ооба",
      "result": "Sonucu Göster"
    },
    "input": {
      "name": "Аты-жөну",
      "email": "Электрондук почта",
      "email_confirmation": "Электрондук почтаны тастыктоо",
      "dial_code": "өлкөнүн коду",
      "phone": "Сиздин телефонуңуздун номуру",
      "field_required": "Милдеттүү түрдө толтурула турган суроолор",
      "phone_required": "Телефон номуру милдеттүү түрдө толтурулушу зарыл",
      "email_required": "Электрондук почта милдеттүү түрдө толтурулушу зарыл",
      "fullname_required": "Толук аты жөнүңүз керектелет"
    },
    "validation": {
      "required": "{attr} Милдеттүү түрдө толтурула турган суроолор",
      "confirm": "{attr} Тастыктоо дал келген жок"
    },
    "result_title": "Önemli!",
    "finish_test": "Тестиңиз аяктады.",
    "finish_test_question": "Сиз тестти кайрадан тапшырасызбы же натыйжасын тастыктайсызбы?",
    "start_over_question": "Тестти кайрадан тапшырууга макулсузбу?",
    "ready_to_test": "Тестти тапшырууга даярсызбы?",
    "audio_instruction": "Аудиону угуп суроолорго жооп бериниз",
    "et": {
      "instruction_1": "Тестти тапшырууга 30 минутага чейин убакыт берилет.",
      "instruction_2": "Тест жалпы 50 суроодон турат.",
      "instruction_3": "Тесттеги графика жана аудио файлдар онлайн жүктөлөт жана жүктөө үчүн жакшы интернет байланыш керектелет.  Баштоонун алдынды байланышты текшериңиз.",
      "instruction_4": "Баштоону баскычын басканда, тест тапшыруу башталат. Эгерде баштоо баскычын басып, тест учурунда чыгып кетсеңиз, тесттен чыгарга чейинки канча суроого туура жооптуу натыйжалар боюнча балл аласыз.",
      "result": {
        "passed": [
          "Куттуктайбыз, {fullname}! Сиз {level} сертификатын алдыңыз!.",
          "Сертификаттын PDF көчүрмөсун жуктоп сертификатыңызды текшериңиз."
        ],
        "review": [
          "Кечириңиз, сиздин баллыңыз {level} сертификатын алуу үчүн жеткиликсиз.",
          "Сунушталган кайталоо көнүгүүлөрүн аяктаңыз. Жана тестти кайрадан тапшырыңыз."
        ],
        "failed": [
          "Кечириңиз, сиз сертификаттык текшерүүдөн өткөн жоксуз. Сертификаттык тестти өтүүгө берилген бардык аракеттерди колдондуңуз.",
          "Суроолор болсо contact support@nexgenenglish.co байланышыңыз."
        ],
        "auto_next": [
          "Сиз сертификаттык тестти үч жолу тапшыра алган жоксуз. Сиз кийинки курсту баштасаңыз болот. Neo сиздин даяр болушуңузду көргөндө, ушул сертификаттык тестти тапшыра аласыз. Тапшырышыңызга телектешпиз. Андан соң, сертификатты алсаңыз болот. Ийгилик.",
          "Эгерде суроолор болсо support@nexgenenglishonline.co байланышыңыз."
        ],
        "ct_landing_failed": [
          "Тилекке каршы тестти тапшыра алган жоксуз.",
          "Эгерде суроолор болсо support@nexgenenglishonline.co байланышыңыз."
        ]
      },
      "failed_test": "Кечириңиз, тестти тапшыра алган жоксуз.",
      "failed_test_description": "Кайталоо көнүгүүлөрүн аяктаңыз жана тестти кайрадан тапшырыңыз.",
      "instruction_plus_1": "Тестти тапшырууга жалпы 20 мүнөт убакыт берилет.",
      "instruction_plus_2": "Тест жалпы 25 суроодон турат."
    },
    "pt": {
      "instruction_1": "Тестти тапшыруу үчүн 20 мүнөт убакыт берилет.",
      "instruction_2": "Бул ылайыкташтырылган тест ошондуктан суроолордун түрү жана саны сиздин туура жооп көрсөткүчтөрүнөн карама каршы.",
      "instruction_3": "Тесттеги графика жана аудио файлдар онлайн жүктөлөт жана жүктөө үчүн жакшы интернет байланыш керектелет.  Баштоонун алдынды байланышты текшериңиз.",
      "instruction_4": "Тестти 3 жолу тапшырсаңыз болот.",
      "instruction_4_1": "Тестти бир гана жолу тапшыра аласыз.",
      "result_correlation": "Натыйжалардын корреляциясы - {level}",
      "cefr_chart": "Графикалык CEFR Level ",
      "result": {
        "c1_pro": "Сиздин англис тили денгээлиңиз абдан жакшы! Биздин англис тилин эне-тил денгээлинде өздөштүрүү курсу даяр боло элек. Даяр болгондо сизге электрондук почтаңызга жазып коебуз!",
        "c1_pro_plus": "Куттуктайбыз! Сиздин англис тили денгээлиңиз абдан жогору. Тилекке каршы, neo тиркемеси жогорку CEFR сертификациялык курстарды сунуштай албайт. Бирок, жогорку денгээлдеги стандарттырылышкан IELTS жана IBT сыяктуу тесттерди ийгиликтүү тапшыруу үчүн C1-Bridge курсу бар."
      }
    },
    "test_time": "Сизде тестти тапшыруу үчүн  жалпы {minutes} бар.",
    "total_questions": "Тест жалпы {total}  суроодон турат.",
    "error": {
      "invalid_credentials": "Туура эмес даректер.",
      "repeat_audio": "Бир гана жолу аудиону кайталасаңыз болот.",
      "start_over_retry": "Кечиресиз, тестти эки жолу гана баштаса болот.",
      "connection_issue": "Баштоонун алдында, интернет байланышын текшериңиз.",
      "student_already_registered": "Бул электрондук почта тиркелген, башканы колдонуңуз.",
      "timeout": "Убакытыңыз бүттү.",
      "email_submitted": "Bu e-postayla ilişkili bir Assessment Test (Düzey Belirleme Sınavı) sonucu zaten bulunmaktadır."
    }
  }
}